"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[160],{

/***/ 6160:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "GT": function() { return /* binding */ Email; },
/* harmony export */   "UW": function() { return /* binding */ Download; }
/* harmony export */ });
/* unused harmony exports DistributeVerticalBottom, DistributeVerticalCenter, DistributeVerticalTop, DnsServices, Doc, Document, DocumentAdd, DocumentAttachment, DocumentAudio, DocumentBlank, DocumentComment, DocumentConfiguration, DocumentDownload, DocumentEpdf, DocumentExport, DocumentHorizontal, DocumentImport, DocumentMultiple_01, DocumentMultiple_02, DocumentPdf, DocumentPreliminary, DocumentProcessor, DocumentProtected, DocumentRequirements, DocumentSecurity, DocumentSentiment, DocumentSet, DocumentSigned, DocumentSketch, DocumentSubject, DocumentSubtract, DocumentTasks, DocumentUnknown, DocumentUnprotected, DocumentVertical, DocumentVideo, DocumentView, DocumentWordProcessor, DocumentWordProcessorReference, Documentation, DogWalker, DotMark, DoubleAxisChartBar, DoubleAxisChartColumn, DoubleInteger, DownToBottom, Downstream, DragHorizontal, DragVertical, Draggable, Draw, DrillBack, DrillDown, DrillThrough, Drink_01, Drink_02, DriverAnalysis, Drone, DroneDelivery, DroneFront, DroneVideo, DropPhoto, DropPhotoFilled, Drought, Dvr, Earth, EarthAmericas, EarthAmericasFilled, EarthEuropeAfrica, EarthEuropeAfricaFilled, EarthFilled, EarthSoutheastAsia, EarthSoutheastAsiaFilled, Earthquake, EdgeCluster, EdgeDevice, EdgeNode, EdgeNodeAlt, EdgeService, Edit, EditOff, EdtLoop, Education, ElementPicker, EmailNew, EmissionsManagement, Encryption, EnergyRenewable, Enterprise, EnumerationDefinition, EnumerationUsage, EqualApproximately, Equalizer, Erase, Error, ErrorFilled, ErrorOutline, Event, EventChange, EventIncident, EventSchedule, EventWarning, Events, EventsAlt, ExamMode, ExecutableProgram, Exit, ExpandAll, ExpandCategories, Explore, Export, Extensions, Eyedropper, FaceActivated, FaceActivatedAdd, FaceActivatedFilled, WatsonHealthDna, WatsonHealthDownloadStudy, WatsonHealthEdgeEnhancement, WatsonHealthEdgeEnhancement_01, WatsonHealthEdgeEnhancement_02, WatsonHealthEdgeEnhancement_03, WatsonHealthErase_3D */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var _Icon_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1239);
/**
 * Copyright IBM Corp. 2016, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * Code generated by @carbon/icon-build-helpers. DO NOT EDIT.
 */






var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _circle, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _circle2, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _circle3, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _circle4, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _circle5, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _circle6, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _circle7, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _circle8, _circle9, _circle0, _circle1, _path267, _path268, _path269, _circle10, _circle11, _circle12, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _circle13, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _circle14, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _circle15, _circle16, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414;
const DistributeVerticalBottom = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function DistributeVerticalBottom({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 28H30V30H2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24,26H8a2.0021,2.0021,0,0,1-2-2V20a2.0021,2.0021,0,0,1,2-2H24a2.0021,2.0021,0,0,1,2,2v4A2.0021,2.0021,0,0,1,24,26Zm0-6.0012L8,20v4H24Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2 12H30V14H2z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20,10H12a2.0021,2.0021,0,0,1-2-2V4a2.0021,2.0021,0,0,1,2-2h8a2.0021,2.0021,0,0,1,2,2V8A2.0021,2.0021,0,0,1,20,10Zm0-6.0012L12,4V8h8Z"
  })), children);
})));
if (false) {}
const DistributeVerticalCenter = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function DistributeVerticalCenter({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30,21H26V20a2.0023,2.0023,0,0,0-2-2H8a2.0023,2.0023,0,0,0-2,2v1H2v2H6v1a2.0023,2.0023,0,0,0,2,2H24a2.0023,2.0023,0,0,0,2-2V23h4Zm-6,3H8V20l16-.001Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30,9H22V8a2.0023,2.0023,0,0,0-2-2H12a2.0023,2.0023,0,0,0-2,2V9H2v2h8v1a2.0023,2.0023,0,0,0,2,2h8a2.0023,2.0023,0,0,0,2-2V11h8ZM20,12H12V8l8-.001Z"
  })), children);
})));
if (false) {}
const DistributeVerticalTop = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function DistributeVerticalTop({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M24,30H8a2.0021,2.0021,0,0,1-2-2V24a2.0021,2.0021,0,0,1,2-2H24a2.0021,2.0021,0,0,1,2,2v4A2.0021,2.0021,0,0,1,24,30ZM8,24v4H24V24Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M2 18H30V20H2z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M20,14H12a2.0021,2.0021,0,0,1-2-2V8a2.0021,2.0021,0,0,1,2-2h8a2.0021,2.0021,0,0,1,2,2v4A2.0021,2.0021,0,0,1,20,14ZM12,8v4h8V8Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M2 2H30V4H2z"
  })), children);
})));
if (false) {}
const WatsonHealthDna = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function WatsonHealthDna({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M22,2V1H20V2a7.04,7.04,0,0,1-.08,1H12.08A7.04,7.04,0,0,1,12,2V1H10V2c0,3.7549,1.9707,5.6035,4.1008,7C11.9707,10.3965,10,12.2451,10,16s1.9707,5.6035,4.1008,7C11.9707,24.3965,10,26.2451,10,30v1h2V30a7.04,7.04,0,0,1,.08-1H19.92A7.04,7.04,0,0,1,20,30v1h2V30c0-3.7549-1.9707-5.6035-4.1008-7C20.0293,21.6035,22,19.7549,22,16s-1.9707-5.6035-4.1008-7C20.0293,7.6035,22,5.7549,22,2ZM20,16a7.04,7.04,0,0,1-.08,1H12.08a6.3212,6.3212,0,0,1,0-2H19.92A7.04,7.04,0,0,1,20,16Zm-.7559,11H12.7559A8.9078,8.9078,0,0,1,16,24.17,8.9078,8.9078,0,0,1,19.2441,27ZM16,21.83A8.9078,8.9078,0,0,1,12.7559,19h6.4882A8.9078,8.9078,0,0,1,16,21.83ZM19.2441,13H12.7559A8.9078,8.9078,0,0,1,16,10.17,8.9078,8.9078,0,0,1,19.2441,13ZM16,7.83A8.9078,8.9078,0,0,1,12.7559,5h6.4882A8.9078,8.9078,0,0,1,16,7.83Z"
  })), children);
})));
if (false) {}
const DnsServices = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function DnsServices({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M20 20H30V22H20z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M20 24H26V26H20z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M30,17V16A13.9871,13.9871,0,1,0,19.23,29.625l-.46-1.9463A12.0419,12.0419,0,0,1,16,28c-.19,0-.375-.0186-.563-.0273A20.3044,20.3044,0,0,1,12.0259,17Zm-2.0415-2H21.9751A24.2838,24.2838,0,0,0,19.2014,4.4414,12.0228,12.0228,0,0,1,27.9585,15ZM16.563,4.0273A20.3044,20.3044,0,0,1,19.9741,15H12.0259A20.3044,20.3044,0,0,1,15.437,4.0273C15.625,4.0186,15.81,4,16,4S16.375,4.0186,16.563,4.0273Zm-3.7644.4141A24.2838,24.2838,0,0,0,10.0249,15H4.0415A12.0228,12.0228,0,0,1,12.7986,4.4414Zm0,23.1172A12.0228,12.0228,0,0,1,4.0415,17h5.9834A24.2838,24.2838,0,0,0,12.7986,27.5586Z"
  })), children);
})));
if (false) {}
const Doc = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Doc({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M30,23H24a2.0023,2.0023,0,0,1-2-2V11a2.002,2.002,0,0,1,2-2h6v2H24V21h6Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M18,23H14a2.0023,2.0023,0,0,1-2-2V11a2.002,2.002,0,0,1,2-2h4a2.002,2.002,0,0,1,2,2V21A2.0023,2.0023,0,0,1,18,23ZM14,11V21h4V11Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M6,23H2V9H6a4.0045,4.0045,0,0,1,4,4v6A4.0045,4.0045,0,0,1,6,23ZM4,21H6a2.002,2.002,0,0,0,2-2V13a2.002,2.002,0,0,0-2-2H4Z"
  })), children);
})));
if (false) {}
const Document = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Document({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7,9.3l-7-7C18.5,2.1,18.3,2,18,2H8C6.9,2,6,2.9,6,4v24c0,1.1,0.9,2,2,2h16c1.1,0,2-0.9,2-2V10C26,9.7,25.9,9.5,25.7,9.3 z M18,4.4l5.6,5.6H18V4.4z M24,28H8V4h8v6c0,1.1,0.9,2,2,2h6V28z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M10 22H22V24H10z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M10 16H22V18H10z"
  })), children);
})));
if (false) {}
const DocumentAdd = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function DocumentAdd({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M30 24 26 24 26 20 24 20 24 24 20 24 20 26 24 26 24 30 26 30 26 26 30 26 30 24z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M16,28H8V4h8v6a2.0058,2.0058,0,0,0,2,2h6v4h2V10a.9092.9092,0,0,0-.3-.7l-7-7A.9087.9087,0,0,0,18,2H8A2.0058,2.0058,0,0,0,6,4V28a2.0058,2.0058,0,0,0,2,2h8ZM18,4.4,23.6,10H18Z"
  })), children);
})));
if (false) {}
const DocumentAttachment = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function DocumentAttachment({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M26,30H11a2.0023,2.0023,0,0,1-2-2V22h2v6H26V6H17V4h9a2.0023,2.0023,0,0,1,2,2V28A2.0023,2.0023,0,0,1,26,30Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M17 10H24V12H17z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M16 15H24V17H16z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M15 20H24V22H15z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M9,19a5.0055,5.0055,0,0,1-5-5V3H6V14a3,3,0,0,0,6,0V5a1,1,0,0,0-2,0V15H8V5a3,3,0,0,1,6,0v9A5.0055,5.0055,0,0,1,9,19Z"
  })), children);
})));
if (false) {}
const DocumentAudio = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function DocumentAudio({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M29,31a.9987.9987,0,0,1-.6245-.2192L23.6494,27H20a1,1,0,0,1-1-1V21a1,1,0,0,1,1-1h3.6494l4.7261-3.7808A1,1,0,0,1,30,17V30a1,1,0,0,1-1,1Zm-8-6h3a1,1,0,0,1,.6245.2192L28,27.9194V19.0806l-3.3755,2.7A1,1,0,0,1,24,22H21Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M16,28H8V4h8v6a2.0058,2.0058,0,0,0,2,2h6v3l2,0V10a.9092.9092,0,0,0-.3-.7l-7-7A.9087.9087,0,0,0,18,2H8A2.0058,2.0058,0,0,0,6,4V28a2.0058,2.0058,0,0,0,2,2h8ZM18,4.4,23.6,10H18Z"
  })), children);
})));
if (false) {}
const DocumentBlank = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function DocumentBlank({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7,9.3l-7-7A.9078.9078,0,0,0,18,2H8A2.0059,2.0059,0,0,0,6,4V28a2.0059,2.0059,0,0,0,2,2H24a2.0059,2.0059,0,0,0,2-2V10A.9078.9078,0,0,0,25.7,9.3ZM18,4.4,23.6,10H18ZM24,28H8V4h8v6a2.0059,2.0059,0,0,0,2,2h6Z"
  })), children);
})));
if (false) {}
const DocumentComment = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function DocumentComment({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m26,17h-10c-1.104.0014-1.9986.896-2,2v6c0,1.1046.8954,2,2,2h4v-2h-4v-6h10v6h-2.5352l-2.5937,3.8906,1.6641,1.1094,2-3h1.4648c1.1046,0,2-.8954,2-2v-6c-.0014-1.104-.896-1.9986-2-2Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m22,14h2v-4c0-.2998-.1001-.5-.3-.7002l-7-7c-.2-.1997-.3999-.2998-.7-.2998H6c-1.1001,0-2,.8999-2,2v24c0,1.1001.8999,2,2,2h6v-2h-6V4h8v6c0,1.1001.8999,2,2,2h6v2Zm-6-4v-5.6001l5.6001,5.6001h-5.6001Z"
  })), children);
})));
if (false) {}
const DocumentConfiguration = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function DocumentConfiguration({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m30,24v-2h-2.1011c-.1289-.6259-.3775-1.2211-.7319-1.7529l1.49-1.49-1.414-1.414-1.49,1.49c-.5318-.3545-1.127-.603-1.753-.732v-2.1011h-2v2.1011c-.6259.1289-1.2211.3775-1.7529.7319l-1.49-1.49-1.414,1.414,1.49,1.49c-.3545.5318-.603,1.127-.732,1.753h-2.1011v2h2.1011c.1289.6259.3775,1.2211.7319,1.7529l-1.49,1.49,1.414,1.414,1.49-1.49c.5318.3545,1.127.603,1.753.732v2.1011h2v-2.1011c.6259-.1289,1.2211-.3775,1.7529-.7319l1.49,1.49,1.414-1.414-1.49-1.49c.3545-.5318.603-1.127.732-1.753h2.1011Zm-7,2c-1.6569,0-3-1.3431-3-3s1.3431-3,3-3,3,1.3431,3,3c-.0018,1.6561-1.3439,2.9982-3,3Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m23.499,9.085l-6.792-6.792c-.1875-.1875-.4419-.293-.707-.293H6c-1.1001,0-2,.8999-2,2v24c0,1.1001.8999,2,2,2h8v-2H6V4h8v6c0,1.1025.897,2,2,2h6.292c.6929,0,1.312-.4136,1.5771-1.0537.2656-.6406.1201-1.3711-.3701-1.8613Zm-7.499.915v-5.5859l5.5854,5.5859h-5.5854Z"
  })), children);
})));
if (false) {}
const DocumentDownload = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function DocumentDownload({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M30 25 28.586 23.586 26 26.172 26 18 24 18 24 26.172 21.414 23.586 20 25 25 30 30 25z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M18,28H8V4h8v6a2.0058,2.0058,0,0,0,2,2h6v3l2,0V10a.9092.9092,0,0,0-.3-.7l-7-7A.9087.9087,0,0,0,18,2H8A2.0058,2.0058,0,0,0,6,4V28a2.0058,2.0058,0,0,0,2,2H18ZM18,4.4,23.6,10H18Z"
  })), children);
})));
if (false) {}
const DocumentEpdf = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function DocumentEpdf({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M28,26V22a2.0023,2.0023,0,0,0-2-2H22a2.0023,2.0023,0,0,0-2,2v6a2.0077,2.0077,0,0,0,2,2h5V28H22V26Zm-6-4h4v2H22Z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M25.707,9.293l-7-7A1,1,0,0,0,18,2H8A2.002,2.002,0,0,0,6,4V28a2.0023,2.0023,0,0,0,2,2h8V28H8V4h8v6a2.002,2.002,0,0,0,2,2h6v4h2V10A1,1,0,0,0,25.707,9.293ZM18,4.4141,23.5859,10H18Z"
  })), children);
})));
if (false) {}
const DocumentExport = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function DocumentExport({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M13 21 26.17 21 23.59 23.59 25 25 30 20 25 15 23.59 16.41 26.17 19 13 19 13 21z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M22,14V10a1,1,0,0,0-.29-.71l-7-7A1,1,0,0,0,14,2H4A2,2,0,0,0,2,4V28a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2V26H20v2H4V4h8v6a2,2,0,0,0,2,2h6v2Zm-8-4V4.41L19.59,10Z"
  })), children);
})));
if (false) {}
const DocumentHorizontal = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function DocumentHorizontal({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M28,6H4A2.0023,2.0023,0,0,0,2,8V24a2.0023,2.0023,0,0,0,2,2H28a2.0023,2.0023,0,0,0,2-2V8A2.0023,2.0023,0,0,0,28,6ZM20,24H12V22a1,1,0,0,1,1-1h6a1,1,0,0,1,1,1Zm8,0H22V22a3,3,0,0,0-3-3H13a3,3,0,0,0-3,3v2H4V8H28Z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M16,18a4,4,0,1,0-4-4A4,4,0,0,0,16,18Zm0-6a2,2,0,1,1-2,2A2,2,0,0,1,16,12Z"
  })), children);
})));
if (false) {}
const DocumentImport = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function DocumentImport({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M28 19 14.83 19 17.41 16.41 16 15 11 20 16 25 17.41 23.59 14.83 21 28 21 28 19z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M24,14V10a1,1,0,0,0-.29-.71l-7-7A1,1,0,0,0,16,2H6A2,2,0,0,0,4,4V28a2,2,0,0,0,2,2H22a2,2,0,0,0,2-2V26H22v2H6V4h8v6a2,2,0,0,0,2,2h6v2Zm-8-4V4.41L21.59,10Z"
  })), children);
})));
if (false) {}
const DocumentMultiple_01 = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function DocumentMultiple_01({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M2 6H4V26H2z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M6 4H8V28H6z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M14 22H26V24H14z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M14 16H26V18H14z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7,9.3l-7-7C22.5,2.1,22.3,2,22,2H12c-1.1,0-2,0.9-2,2v24c0,1.1,0.9,2,2,2h16c1.1,0,2-0.9,2-2V10 C30,9.7,29.9,9.5,29.7,9.3z M22,4.4l5.6,5.6H22V4.4z M28,28H12V4h8v6c0,1.1,0.9,2,2,2h6V28z"
  })), children);
})));
if (false) {}
const DocumentMultiple_02 = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function DocumentMultiple_02({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M18,31H6c-1.1,0-2-0.9-2-2V12h2v17h12V31z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M22,27H10c-1.1,0-2-0.9-2-2V8h2v17h12V27z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M16 16H24V18H16z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7,9.3l-7-7C20.5,2.1,20.3,2,20,2h-6c-1.1,0-2,0.9-2,2v17c0,1.1,0.9,2,2,2h12c1.1,0,2-0.9,2-2V10 C28,9.7,27.9,9.5,27.7,9.3z M20,4.4l5.6,5.6H20V4.4z M26,21H14V4h4v6c0,1.1,0.9,2,2,2h6V21z"
  })), children);
})));
if (false) {}
const DocumentPdf = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function DocumentPdf({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M30 18 30 16 24 16 24 26 26 26 26 22 29 22 29 20 26 20 26 18 30 18z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M19,26H15V16h4a3.0033,3.0033,0,0,1,3,3v4A3.0033,3.0033,0,0,1,19,26Zm-2-2h2a1.0011,1.0011,0,0,0,1-1V19a1.0011,1.0011,0,0,0-1-1H17Z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M11,16H6V26H8V23h3a2.0027,2.0027,0,0,0,2-2V18A2.0023,2.0023,0,0,0,11,16ZM8,21V18h3l.001,3Z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M22,14V10a.9092.9092,0,0,0-.3-.7l-7-7A.9087.9087,0,0,0,14,2H4A2.0059,2.0059,0,0,0,2,4V28a2,2,0,0,0,2,2H20V28H4V4h8v6a2.0059,2.0059,0,0,0,2,2h6v2Zm-8-4V4.4L19.6,10Z"
  })), children);
})));
if (false) {}
const DocumentPreliminary = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function DocumentPreliminary({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M24,30a6,6,0,1,1,6-6A6.0067,6.0067,0,0,1,24,30Zm0-10a4,4,0,1,0,4,4A4.0045,4.0045,0,0,0,24,20Z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M8 22H16V24H8z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M8 16H18V18H8z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M16,28H6V4h8v6a2.0058,2.0058,0,0,0,2,2h6v3h2V10a.9092.9092,0,0,0-.3-.7l-7-7A.9087.9087,0,0,0,16,2H6A2.0058,2.0058,0,0,0,4,4V28a2.0058,2.0058,0,0,0,2,2H16ZM16,4.4,21.6,10H16Z"
  })), children);
})));
if (false) {}
const DocumentProcessor = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function DocumentProcessor({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M21,28v2h-2c-1.1025,0-2-.8975-2-2v-2h2v2h2Z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M26,26h2v2c0,1.1025-.8975,2-2,2h-2v-2h2v-2Z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M24,21v-2h2c1.1025,0,2,.8975,2,2v2h-2v-2h-2Z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M19,23h-2v-2c0-1.1025.8975-2,2-2h2v2h-2v2Z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M14,28h-6V4h8v6c0,1.1001.8999,2,2,2h6v4h2v-6c0-.2998-.1001-.5-.3-.7002l-7-7c-.2-.1997-.3999-.2998-.7-.2998h-10c-1.1001,0-2,.8999-2,2v24c0,1.1001.8999,2,2,2h6v-2ZM18,4.3999l5.6001,5.6001h-5.6001v-5.6001Z"
  })), children);
})));
if (false) {}
const DocumentProtected = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function DocumentProtected({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M28,21V18a4,4,0,0,0-8,0v3a2.0025,2.0025,0,0,0-2,2v5a2.0025,2.0025,0,0,0,2,2h8a2.0025,2.0025,0,0,0,2-2V23A2.0025,2.0025,0,0,0,28,21Zm-6-3a2,2,0,0,1,4,0v3H22ZM20,28V23h8v5Z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M23.499,9.085,16.707,2.293A1,1,0,0,0,16,2H6A2.0058,2.0058,0,0,0,4,4V28a2.0058,2.0058,0,0,0,2,2h8V28H6V4h8v6a2.0023,2.0023,0,0,0,2,2h6.292a1.7075,1.7075,0,0,0,1.207-2.915ZM16,10V4.4141L21.5854,10Z"
  })), children);
})));
if (false) {}
const DocumentRequirements = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function DocumentRequirements({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "M28.5899 20.59 22 27.1798 19.41 24.5898 18 26 22 30 30 22 28.5899 20.59z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "M10 20H16V22H10z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "M10 16H18V18H10z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m8,4h8v6c0,1.1001.8999,2,2,2h6v6h2v-8c0-.2998-.1001-.5-.3-.7002l-7-7c-.2-.1997-.3999-.2998-.7-.2998h-10c-1.1001,0-2,.8999-2,2v24c0,1.1001.8999,2,2,2h7v-2h-7V4Zm10,.3999l5.6001,5.6001h-5.6001v-5.6001Z"
  })), children);
})));
if (false) {}
const DocumentSecurity = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function DocumentSecurity({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M23,30l-2.1387-1.0127A5.0216,5.0216,0,0,1,18,24.4678V18H28v6.4678a5.0216,5.0216,0,0,1-2.8613,4.52ZM20,20v4.4678a3.012,3.012,0,0,0,1.7168,2.7109L23,27.7861l1.2832-.6074A3.012,3.012,0,0,0,26,24.4678V20Z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M16,28H6V4h8v6a2.0058,2.0058,0,0,0,2,2h6v3h2V10a.9092.9092,0,0,0-.3-.7l-7-7A.9087.9087,0,0,0,16,2H6A2.0058,2.0058,0,0,0,4,4V28a2.0058,2.0058,0,0,0,2,2H16ZM16,4.4,21.6,10H16Z"
  })), children);
})));
if (false) {}
const DocumentSigned = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function DocumentSigned({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4141,30H15V25.5857l5.0337-5.0337A4.6069,4.6069,0,0,1,20,20a5,5,0,1,1,4.4478,4.9663ZM17,28h1.5859l5.2061-5.2063.5395.1238a3.0351,3.0351,0,1,0-2.249-2.2488l.1236.5393L17,26.4143Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: "25",
    cy: "20",
    r: "1"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M8 6H20V8H8z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M8 10H20V12H8z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M8 14H14V16H8z"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M8 24H12V26H8z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M12,30H6a2.0021,2.0021,0,0,1-2-2V4A2.0021,2.0021,0,0,1,6,2H22a2.0021,2.0021,0,0,1,2,2v9H22V4H6V28h6Z"
  })), children);
})));
if (false) {}
const DocumentSketch = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function DocumentSketch({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M26,20l1.4272,1.9028L23,26.9629l-4.4272-5.06L20,20h6m1-2H19l-3,4,7,8,7-8-3-4Z"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M16,28H8V4h8v6a2.0058,2.0058,0,0,0,2,2h6v3l2,0V10a.9092.9092,0,0,0-.3-.7l-7-7A.9087.9087,0,0,0,18,2H8A2.0058,2.0058,0,0,0,6,4V28a2.0058,2.0058,0,0,0,2,2h8ZM18,4.4,23.6,10H18Z"
  })), children);
})));
if (false) {}
const DocumentSubject = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function DocumentSubject({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m26,30h-5v-2h5v-2h-3c-1.1025,0-2-.8975-2-2v-2c0-1.103.8975-2,2-2h5v2h-5v2h3c1.1025,0,2,.8975,2,2v2c0,1.1025-.8975,2-2,2Z"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "M10 20H16V22H10z"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "M10 16H18V18H10z"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m24,16.9922h2v-6.9922c0-.1001,0-.2998-.1001-.3999-.0999-.1001-.0999-.2002-.2-.3003l-7-7c-.0999-.0996-.2-.1997-.3-.1997-.0999-.1001-.2998-.1001-.3999-.1001h-10c-.5,0-1,.2002-1.3999.6001-.4001.3999-.6001.8999-.6001,1.3999v24c0,.5.2,1,.6001,1.3999.3999.3999.8999.6001,1.3999.6001h7.9473v-2h-7.9473V4h8v6c0,.5.2,1,.6001,1.3999.3999.3999.8999.6001,1.3999.6001h6v4.9922Zm-6-6.9922v-5.6001l5.6001,5.6001h-5.6001Z"
  })), children);
})));
if (false) {}
const DocumentSubtract = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function DocumentSubtract({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M20 24H30V26H20z"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M16,28H8V4h8v6a2.0058,2.0058,0,0,0,2,2h6v8h2V10a.9092.9092,0,0,0-.3-.7l-7-7A.9087.9087,0,0,0,18,2H8A2.0058,2.0058,0,0,0,6,4V28a2.0058,2.0058,0,0,0,2,2h8ZM18,4.4,23.6,10H18Z"
  })), children);
})));
if (false) {}
const DocumentTasks = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function DocumentTasks({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M22 27.18 19.41 24.59 18 26 22 30 30 22 28.59 20.59 22 27.18z"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M15,28H8V4h8v6a2.0058,2.0058,0,0,0,2,2h6v6h2V10a.9092.9092,0,0,0-.3-.7l-7-7A.9087.9087,0,0,0,18,2H8A2.0058,2.0058,0,0,0,6,4V28a2.0058,2.0058,0,0,0,2,2h7ZM18,4.4,23.6,10H18Z"
  })), children);
})));
if (false) {}
const DocumentUnknown = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function DocumentUnknown({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: "9",
    cy: "28.5",
    r: "1.5"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M10,25H8V21h2a2,2,0,0,0,0-4H8a2.0023,2.0023,0,0,0-2,2v.5H4V19a4.0045,4.0045,0,0,1,4-4h2a4,4,0,0,1,0,8Z"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7,9.3l-7-7A.9085.9085,0,0,0,20,2H10A2.0058,2.0058,0,0,0,8,4v8h2V4h8v6a2.0058,2.0058,0,0,0,2,2h6V28H14v2H26a2.0058,2.0058,0,0,0,2-2V10A.9092.9092,0,0,0,27.7,9.3ZM20,10V4.4L25.6,10Z"
  })), children);
})));
if (false) {}
const DocumentUnprotected = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function DocumentUnprotected({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M23.499,9.085,16.707,2.293A1,1,0,0,0,16,2H6A2.0058,2.0058,0,0,0,4,4V28a2.0058,2.0058,0,0,0,2,2h8V28H6V4h8v6a2.0023,2.0023,0,0,0,2,2h6.292a1.7075,1.7075,0,0,0,1.207-2.915ZM16,10V4.4141L21.5854,10Z"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M28,21H22V18a2,2,0,0,1,4,0h2a4,4,0,0,0-8,0v3a2.0025,2.0025,0,0,0-2,2v5a2.0025,2.0025,0,0,0,2,2h8a2.0025,2.0025,0,0,0,2-2V23A2.0025,2.0025,0,0,0,28,21Zm-8,7V23h8v5Z"
  })), children);
})));
if (false) {}
const DocumentVertical = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function DocumentVertical({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M16,14a4,4,0,1,1,4-4h0A4.0118,4.0118,0,0,1,16,14Zm0-6a2,2,0,1,0,2,2h0a2.0059,2.0059,0,0,0-2-2Z"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M24,2H8A2.0023,2.0023,0,0,0,6,4V28a2.0023,2.0023,0,0,0,2,2H24a2.0023,2.0023,0,0,0,2-2V4A2.0023,2.0023,0,0,0,24,2ZM12,24V18a.9447.9447,0,0,1,1-1h6a.9447.9447,0,0,1,1,1v6H18v4H14V24Zm8,4V26a2.0058,2.0058,0,0,0,2-2V18a2.9463,2.9463,0,0,0-3-3H13a2.9463,2.9463,0,0,0-3,3v6a2.0058,2.0058,0,0,0,2,2v2H8V4H24V28Z"
  })), children);
})));
if (false) {}
const DocumentVideo = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function DocumentVideo({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M30,19l-4,3.2V20a2.0023,2.0023,0,0,0-2-2H16a2.0023,2.0023,0,0,0-2,2v6a2.0023,2.0023,0,0,0,2,2h8a2.0023,2.0023,0,0,0,2-2V23.8L30,27ZM16,26V20h8l.0015,6Z"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M12,28H8V4h8v6a2.0058,2.0058,0,0,0,2,2h6v3l2,0V10a.9092.9092,0,0,0-.3-.7l-7-7A.9087.9087,0,0,0,18,2H8A2.0058,2.0058,0,0,0,6,4V28a2.0058,2.0058,0,0,0,2,2h4ZM18,4.4,23.6,10H18Z"
  })), children);
})));
if (false) {}
const DocumentView = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function DocumentView({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: "22",
    cy: "24",
    r: "2"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M22,28a4,4,0,1,1,4-4A4.0039,4.0039,0,0,1,22,28Zm0-6a2,2,0,1,0,2,2A2.0027,2.0027,0,0,0,22,22Z"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7769,23.4785A8.64,8.64,0,0,0,22,18a8.64,8.64,0,0,0-7.7769,5.4785L14,24l.2231.5215A8.64,8.64,0,0,0,22,30a8.64,8.64,0,0,0,7.7769-5.4785L30,24ZM22,28a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,22,28Z"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M12,28H8V4h8v6a2.0058,2.0058,0,0,0,2,2h6v4h2V10a.9092.9092,0,0,0-.3-.7l-7-7A.9087.9087,0,0,0,18,2H8A2.0058,2.0058,0,0,0,6,4V28a2.0058,2.0058,0,0,0,2,2h4ZM18,4.4,23.6,10H18Z"
  })), children);
})));
if (false) {}
const DocumentWordProcessor = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function DocumentWordProcessor({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3 20 27.391 28.611 26 20 24 20 22.609 28.611 21.7 20 20 20 21.36 30 23.64 30 25 21.626 26.36 30 28.64 30 30 20 28.3 20z"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M25.707,9.293l-7-7A1,1,0,0,0,18,2H8A2.002,2.002,0,0,0,6,4V28a2.0023,2.0023,0,0,0,2,2h8V28H8V4h8v6a2.002,2.002,0,0,0,2,2h6v4h2V10A1,1,0,0,0,25.707,9.293ZM18,4.4141,23.5859,10H18Z"
  })), children);
})));
if (false) {}
const DocumentWordProcessorReference = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function DocumentWordProcessorReference({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3 20 27.391 28.611 26 20 24 20 22.609 28.611 21.7 20 20 20 21.36 30 23.64 30 25 21.626 26.36 30 28.64 30 30 20 28.3 20z"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M4 20 4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20z"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M25.707,9.293l-7-7A1,1,0,0,0,18,2H8A2.002,2.002,0,0,0,6,4V16H8V4h8v6a2.002,2.002,0,0,0,2,2h6v4h2V10A1,1,0,0,0,25.707,9.293ZM18,10V4.4141L23.5859,10Z"
  })), children);
})));
if (false) {}
const DocumentSentiment = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function DocumentSentiment({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M18.303,16a2.6616,2.6616,0,0,0-1.9079.8058l-.3932.4054-.397-.4054a2.6615,2.6615,0,0,0-3.8157,0,2.7992,2.7992,0,0,0,0,3.8964L16.0019,25l4.2089-4.2978a2.7992,2.7992,0,0,0,0-3.8964A2.6616,2.6616,0,0,0,18.303,16Z"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7,9.3l-7-7A.9078.9078,0,0,0,18,2H8A2.0059,2.0059,0,0,0,6,4V28a2.0059,2.0059,0,0,0,2,2H24a2.0059,2.0059,0,0,0,2-2V10A.9078.9078,0,0,0,25.7,9.3ZM18,4.4,23.6,10H18ZM24,28H8V4h8v6a2.0059,2.0059,0,0,0,2,2h6Z"
  })), children);
})));
if (false) {}
const DocumentSet = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function DocumentSet({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M12,4h8v6c0,1.1.9,2,2,2h6v6h2v-8c0-.3-.1-.5-.3-.7l-7-7c-.2-.2-.4-.3-.7-.3h-10c-1.1,0-2,.9-2,2v24c0,1.1.9,2,2,2h4v-2h-4V4ZM22,4.4l5.6,5.6h-5.6v-5.6ZM30,22l-8,8-4-4,1.4-1.4,2.6,2.6,6.6-6.6,1.4,1.4ZM4,27h-2V7h2v20ZM8,28h-2V4h2v24Z"
  })), children);
})));
if (false) {}
const Documentation = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Documentation({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3164,9.4912l-8.0041-6.997c-.3644-.3186-.8322-.4942-1.3163-.4942H4c-1.1046,0-2,.8954-2,2v24c0,1.1046.8954,2,2,2h24c1.1046,0,2-.8954,2-2V10.997c0-.577-.2493-1.126-.6837-1.5058ZM28,13v15H4V4h14v7c0,1.1046.8954,2,2,2l8,.0012M6,14h4.3682c3.1294,0,5.1758,2.0088,5.1758,5.998s-2.0464,6.002-5.1758,6.002h-4.3682v-12ZM10.3682,23.9883c1.6851,0,2.7686-.998,2.7686-3.0439v-1.8887c0-2.0469-1.0835-3.0439-2.7686-3.0439h-2.0981v7.9766h2.0981ZM17,21.4941c0-2.8711,1.5991-4.6768,4.1611-4.6768,2.5796,0,4.1792,1.8057,4.1792,4.6768,0,2.8896-1.5996,4.7119-4.1792,4.7119-2.562,0-4.1611-1.8223-4.1611-4.7119ZM23.0356,22.3369v-1.668c0-1.3408-.7222-2.0811-1.8745-2.0811-1.1348,0-1.8569.7402-1.8569,2.0811v1.668c0,1.3584.7222,2.0986,1.8569,2.0986,1.1523,0,1.8745-.7402,1.8745-2.0986Z"
  })), children);
})));
if (false) {}
const DogWalker = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function DogWalker({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M20 20H22V30H20z"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M4 23H6V30H4z"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30H14V26a1.0011,1.0011,0,0,0-1-1H11v5H9V23h4a3.0033,3.0033,0,0,1,3,3Z"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5,22A3.5041,3.5041,0,0,1,4,18.5V17H2V15H6v3.5a1.5,1.5,0,0,0,3,0V15h4v2H11v1.5A3.5041,3.5041,0,0,1,7.5,22Z"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M27,10H21.354a2.9861,2.9861,0,0,0-2.7856,1.8857l-1.4419,3.6055-3.6079,4.51,1.562,1.249,3.7-4.625,1.645-3.9961A.9949.9949,0,0,1,21.354,12H27a1.0009,1.0009,0,0,1,1,1v7H25V30h2V22h1a2.0023,2.0023,0,0,0,2-2V13A3.0033,3.0033,0,0,0,27,10Z"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M24,9a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,24,9Zm0-6a2,2,0,1,0,2,2A2.0021,2.0021,0,0,0,24,3Z"
  })), children);
})));
if (false) {}
const DotMark = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function DotMark({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "16",
    r: "8"
  })), children);
})));
if (false) {}
const DoubleAxisChartBar = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function DoubleAxisChartBar({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M30,4v-2H4c-1.1047,0-2,.8955-2,2v24c0,1.1045.8953,2,2,2h26v-2H4v-3h22v-7H4v-4h14v-7H4v-3h26ZM24,20v3H4v-3h20ZM16,9v3H4v-3h12Z"
  })), children);
})));
if (false) {}
const DoubleAxisChartColumn = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function DoubleAxisChartColumn({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M28,2v26h-3V6h-7v22h-4v-14h-7v14h-3V2h-2v26c0,1.1046.8954,2,2,2h24c1.1046,0,2-.8954,2-2V2h-2ZM12,28h-3v-12h3v12ZM23,28h-3V8h3v20Z"
  })), children);
})));
if (false) {}
const DoubleInteger = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function DoubleInteger({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M17,8V6H13V2H11V6H8V2H6V6H2V8H6v3H2v2H6v4H8V13h3v4h2V13h4V11H13V8Zm-6,3H8V8h3Z"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M30,21V19H26V15H24v4H21V15H19v4H15v2h4v3H15v2h4v4h2V26h3v4h2V26h4V24H26V21Zm-6,3H21V21h3Z"
  })), children);
})));
if (false) {}
const DownToBottom = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function DownToBottom({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M16 18 6 8 7.4 6.6 16 15.2 24.6 6.6 26 8z"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M4 22H28V24H4z"
  })), children);
})));
if (false) {}
const Download = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function Download({
  children,
  size = 16,
  ...rest
}, ref) {
  if (size === 16 || size === "16" || size === "16px") {
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Icon_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor",
      ...rest
    }, _path121 || (_path121 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
      d: "M13 7 12.3 6.3 8.5 10.1 8.5 1 7.5 1 7.5 10.1 3.7 6.3 3 7 8 12z"
    })), _path122 || (_path122 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
      d: "M13,12v2H3v-2H2v2l0,0c0,0.6,0.4,1,1,1h10c0.6,0,1-0.4,1-1l0,0v-2H13z"
    })), children);
  }
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Icon_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path123 || (_path123 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M26,24v4H6V24H4v4H4a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2h0V24Z"
  })), _path124 || (_path124 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M26 14 24.59 12.59 17 20.17 17 2 15 2 15 20.17 7.41 12.59 6 14 16 24 26 14z"
  })), children);
});
if (false) {}
const WatsonHealthDownloadStudy = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function WatsonHealthDownloadStudy({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M30 25 28.586 23.586 26 26.172 26 18 24 18 24 26.172 21.414 23.586 20 25 25 30 30 25z"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M19 14H23V16H19z"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M19 10H26V12H19z"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M9,18h6a3,3,0,0,1,3,3v2H16V21a1,1,0,0,0-1-1H9a1,1,0,0,0-1,1v2H6V21A3,3,0,0,1,9,18Z"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M16,13a4,4,0,1,0-4,4A4,4,0,0,0,16,13Zm-2,0a2,2,0,1,1-2-2A2,2,0,0,1,14,13Z"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M18,26H4V6H28V16h2V6a2,2,0,0,0-2-2H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H18Z"
  })), children);
})));
if (false) {}
const Downstream = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Downstream({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "m5,24c-1.6567,0-3,1.3433-3,3s1.3433,3,3,3,3-1.3433,3-3-1.3433-3-3-3Zm0,4c-.5522,0-1-.4478-1-1s.4478-1,1-1,1,.4478,1,1-.4478,1-1,1Z"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "m16,24c-1.6567,0-3,1.3433-3,3s1.3433,3,3,3,3-1.3433,3-3-1.3433-3-3-3Zm0,4c-.5522,0-1-.4478-1-1s.4478-1,1-1,1,.4478,1,1-.4478,1-1,1Z"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "m27,24c-1.6567,0-3,1.3433-3,3s1.3433,3,3,3,3-1.3433,3-3-1.3433-3-3-3Zm0,4c-.5522,0-1-.4478-1-1s.4478-1,1-1,1,.4478,1,1-.4478,1-1,1Z"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "m29.586,17.5859l-1.5859,1.5859v-3.1719c0-3.5542-2.6646-6.4917-6.0999-6.9355.0623-.3457.0999-.7007.0999-1.0645,0-3.3135-2.6863-6-6-6s-6,2.6865-6,6c0,.3638.0376.7188.0999,1.0645-3.4353.4438-6.0999,3.3813-6.0999,6.9355v3.1714l-1.5859-1.5854-1.4141,1.4141,4,4,4-4-1.4141-1.4141-1.5859,1.5859v-3.1719c0-2.6953,2.1479-4.8848,4.8203-4.9819.8799,1.5063,2.3945,2.5918,4.1797,2.8921v5.2617l-1.5859-1.5859-1.4141,1.4141,4,4,4-4-1.4141-1.4141-1.5859,1.5859v-5.2617c1.7852-.3003,3.2998-1.3857,4.1797-2.8921,2.6724.0972,4.8203,2.2866,4.8203,4.9819v3.1714l-1.5859-1.5854-1.4141,1.4141,4,4,4-4-1.4141-1.4141Zm-13.5859-5.5859c-2.2056,0-4-1.7944-4-4s1.7944-4,4-4,4,1.7944,4,4-1.7944,4-4,4Z"
  })), children);
})));
if (false) {}
const DragHorizontal = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function DragHorizontal({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M12 4 12 15 5.83 15 8.41 12.41 7 11 2 16 7 21 8.41 19.59 5.83 17 12 17 12 28 14 28 14 4 12 4z"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M25 11 23.59 12.41 26.17 15 20 15 20 4 18 4 18 28 20 28 20 17 26.17 17 23.59 19.59 25 21 30 16 25 11z"
  })), children);
})));
if (false) {}
const DragVertical = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function DragVertical({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M4 20 15 20 15 26.17 12.41 23.59 11 25 16 30 21 25 19.59 23.59 17 26.17 17 20 28 20 28 18 4 18 4 20z"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M11 7 12.41 8.41 15 5.83 15 12 4 12 4 14 28 14 28 12 17 12 17 5.83 19.59 8.41 21 7 16 2 11 7z"
  })), children);
})));
if (false) {}
const Draggable = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Draggable({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M10 6H14V10H10z"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M18 6H22V10H18z"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M10 14H14V18H10z"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M18 14H22V18H18z"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M10 22H14V26H10z"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M18 22H22V26H18z"
  })), children);
})));
if (false) {}
const Draw = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Draw({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M19.14,28a3.42,3.42,0,0,1-2.42-5.85L21.86,17a1.42,1.42,0,1,0-2-2L13,21.85a3.5,3.5,0,0,1-4.85,0,3.43,3.43,0,0,1,0-4.84l8.58-8.58a1.42,1.42,0,1,0-2-2L6.41,14.7,5,13.3,13.29,5a3.43,3.43,0,0,1,4.84,4.85L9.56,18.42a1.42,1.42,0,0,0,0,2,1.45,1.45,0,0,0,2,0l6.86-6.86a3.43,3.43,0,1,1,4.85,4.84l-5.15,5.15a1.42,1.42,0,0,0,2,2l4.44-4.43L26,22.56,21.56,27A3.38,3.38,0,0,1,19.14,28Z"
  })), children);
})));
if (false) {}
const DrillBack = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function DrillBack({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M6 22 7.414 20.586 3.828 17 12 17 12 15 3.828 15 7.414 11.414 6 10 0 16 6 22z"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M16,10a5.9815,5.9815,0,0,0-4.2427,1.7573L16,16l-4.2427,4.2427A6,6,0,1,0,16,10Z"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A13.9581,13.9581,0,0,0,6.105,6.105L7.5188,7.5186a12,12,0,1,1,0,16.9628L6.105,25.895A13.9974,13.9974,0,1,0,16,2Z"
  })), children);
})));
if (false) {}
const DrillDown = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function DrillDown({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M10 6 11.414 4.586 15 8.172 15 0 17 0 17 8.172 20.586 4.586 22 6 16 12 10 6z"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M22,16a5.9815,5.9815,0,0,0-1.7573-4.2427L16,16l-4.2427-4.2427A6,6,0,1,0,22,16Z"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M30,16a13.9581,13.9581,0,0,0-4.105-9.895L24.4814,7.5188a12,12,0,1,1-16.9628,0L6.105,6.105A13.9974,13.9974,0,1,0,30,16Z"
  })), children);
})));
if (false) {}
const DrillThrough = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function DrillThrough({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30A14.0158,14.0158,0,0,1,2,16H4A12,12,0,1,0,16,4V2a14,14,0,0,1,0,28Z"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M4 12 4 10 8.586 10 2 3.414 3.414 2 10 8.586 10 4 12 4 12 12 4 12z"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M16,10v6H10a6,6,0,1,0,6-6Z"
  })), children);
})));
if (false) {}
const Drink_01 = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Drink_01({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M23,10.4141l3-3-1.4141-1.4141-3.293,3.293c-.1875,.1875-.293,.4419-.293,.707v4h-7.0742l1.1436,16h8.8613l1.1436-16h-2.0742v-3.5859Zm-.9307,17.5859h-5.1387l-.8564-12h6.8516l-.8564,12Z"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M15,1h-5c-.5522,0-1,.4478-1,1v7.3706c-1.0674,.6055-3,2.1777-3,5.6294v14c0,.5527,.4478,1,1,1h5v-2h-4V15c0-3.7536,3-4.2793,3-4.2793V3h3v7h2V2c0-.5522-.4478-1-1-1Z"
  })), children);
})));
if (false) {}
const Drink_02 = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Drink_02({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M23,10.4141l3-3-1.4141-1.4141-3.293,3.293c-.1875,.1875-.293,.4419-.293,.707v4h-7.0742l1.1436,16h8.8613l1.1436-16h-2.0742v-3.5859Zm-.9307,17.5859h-5.1387l-.8564-12h6.8516l-.8564,12Z"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M16,7.0513v-3.0513c0-.5522-.4478-1-1-1h-6c-.5522,0-1,.4478-1,1v3.0513c-1.2771,1.1411-2,2.7358-2,4.4487V29c0,.5522,.4478,1,1,1h5v-2h-4V11.5c0-2.356,2-3.48,2-3.48v-3.02h4v3.02s2,1.124,2,3.48v.5h2v-.5c0-1.7129-.7229-3.3076-2-4.4487Z"
  })), children);
})));
if (false) {}
const DriverAnalysis = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function DriverAnalysis({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: "22",
    cy: "16",
    r: "2"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M30,15H27.91A6.0048,6.0048,0,0,0,22,10l-.022.001A9.9833,9.9833,0,0,0,4.0508,15H2v2H4.0508A9.9833,9.9833,0,0,0,21.978,21.999L22,22a6.0048,6.0048,0,0,0,5.91-5H30ZM14,8a7.9769,7.9769,0,0,1,5.7383,2.4463A6.0152,6.0152,0,0,0,16.0891,15H6.0693A8.0073,8.0073,0,0,1,14,8Zm0,16a8.0073,8.0073,0,0,1-7.9307-7h10.02a6.0152,6.0152,0,0,0,3.6492,4.5537A7.9769,7.9769,0,0,1,14,24Zm8-4a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,22,20Z"
  })), children);
})));
if (false) {}
const Drone = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Drone({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M7,12a5,5,0,1,1,5-5H10a3,3,0,1,0-3,3Z"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M25,12V10a3,3,0,1,0-3-3H20a5,5,0,1,1,5,5Z"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M7,30A5,5,0,0,1,7,20v2a3,3,0,1,0,3,3h2A5.0055,5.0055,0,0,1,7,30Z"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M25,30a5.0055,5.0055,0,0,1-5-5h2a3,3,0,1,0,3-3V20a5,5,0,0,1,0,10Z"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M20,18.5859V13.4141L25.707,7.707a1,1,0,1,0-1.414-1.414l-4.4995,4.5a3.9729,3.9729,0,0,0-7.587,0L7.707,6.293a.9994.9994,0,0,0-1.414,0h0a.9994.9994,0,0,0,0,1.414L12,13.4141v5.1718L6.293,24.293a.9994.9994,0,0,0,0,1.414h0a.9994.9994,0,0,0,1.414,0l4.5-4.5a3.9729,3.9729,0,0,0,7.587,0l4.4995,4.5a1,1,0,0,0,1.414-1.414ZM18,20a2,2,0,0,1-4,0V12a2,2,0,0,1,4,0Z"
  })), children);
})));
if (false) {}
const DroneDelivery = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function DroneDelivery({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M20,30H12V22h8Zm-6-2h4V24H14Z"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M32 11 22 11 22 13 26 13 26 16 6 16 6 13 10 13 10 11 0 11 0 13 4 13 4 18 9.132 18 6 22.697 6 27 8 27 8 23.303 11.535 18 20.465 18 24 23.303 24 27 26 27 26 22.697 22.868 18 28 18 28 13 32 13 32 11z"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M16,6a5.9817,5.9817,0,0,0-4.2407,1.7593l1.4136,1.4136a3.9936,3.9936,0,0,1,5.6542,0l1.4136-1.4136A5.9814,5.9814,0,0,0,16,6Z"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M8.9324,4.9321l1.4133,1.4136a7.9877,7.9877,0,0,1,11.3086,0l1.4136-1.4136a9.9844,9.9844,0,0,0-14.1355,0Z"
  })), children);
})));
if (false) {}
const DroneFront = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function DroneFront({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M28,19V15H26v2H6V15H4v4h7v4.4116L7,25.6367V30H9V26.8125L12.26,25h7.481L23,26.8125V30h2V25.6367l-4-2.2251V19Zm-9,4H13V19h6Z"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M0 11H10V13H0z"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M22 11H32V13H22z"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M16,6a5.9817,5.9817,0,0,0-4.2407,1.7593l1.4136,1.4136a3.9936,3.9936,0,0,1,5.6542,0l1.4136-1.4136A5.9814,5.9814,0,0,0,16,6Z"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M8.9324,4.9321l1.4133,1.4136a7.9877,7.9877,0,0,1,11.3086,0l1.4136-1.4136a9.9844,9.9844,0,0,0-14.1355,0Z"
  })), children);
})));
if (false) {}
const DroneVideo = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function DroneVideo({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "21",
    r: "1"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M28,19V15H26v2H6V15H4v4h7v4.4116L7,25.6367V30H9V26.8125L12.26,25h7.481L23,26.8125V30h2V25.6367l-4-2.2251V19Zm-9,4H13V19h6Z"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M0 11H10V13H0z"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M22 11H32V13H22z"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M16,6a5.9817,5.9817,0,0,0-4.2407,1.7593l1.4136,1.4136a3.9936,3.9936,0,0,1,5.6542,0l1.4136-1.4136A5.9814,5.9814,0,0,0,16,6Z"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M8.9324,4.9321l1.4133,1.4136a7.9877,7.9877,0,0,1,11.3086,0l1.4136-1.4136a9.9844,9.9844,0,0,0-14.1355,0Z"
  })), children);
})));
if (false) {}
const DropPhoto = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function DropPhoto({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M19,26a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,19,26Zm0-6a2,2,0,1,0,2,2A2.0021,2.0021,0,0,0,19,20Z"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M27,29H11a2,2,0,0,1-2-2V18a2,2,0,0,1,2-2h3.2793l.5441-1.6324A2,2,0,0,1,16.7208,13h4.5584a2,2,0,0,1,1.8974,1.3676L23.7207,16H27a2,2,0,0,1,2,2v9A2,2,0,0,1,27,29ZM11,27H27V18H22.2792l-1-3H16.7207l-1,3H11Z"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M27 11H29V13H27z"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M27 7H29V9H27z"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M27 3H29V5H27z"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M23 3H25V5H23z"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M19 3H21V5H19z"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M15 3H17V5H15z"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M11 3H13V5H11z"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M7 3H9V5H7z"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M3 3H5V5H3z"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M3 7H5V9H3z"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M3 11H5V13H3z"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M3 15H5V17H3z"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M3 19H5V21H3z"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M3 23H5V25H3z"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M3 27H5V29H3z"
  })), children);
})));
if (false) {}
const DropPhotoFilled = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function DropPhotoFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: "19",
    cy: "22",
    r: "2"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M27,16H23.7207l-.5439-1.6328A1.9983,1.9983,0,0,0,21.2793,13H16.7207a1.9981,1.9981,0,0,0-1.8975,1.3677L14.2793,16H11a2.0023,2.0023,0,0,0-2,2v9a2.0023,2.0023,0,0,0,2,2H27a2.0023,2.0023,0,0,0,2-2V18A2.0023,2.0023,0,0,0,27,16ZM19,26a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,19,26Z"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M19,26a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,19,26Zm0-6a2,2,0,1,0,2,2A2.0021,2.0021,0,0,0,19,20Z",
    "data-icon-path": "inner-path"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M27 11H29V13H27z"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M27 7H29V9H27z"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M27 3H29V5H27z"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M23 3H25V5H23z"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M19 3H21V5H19z"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M15 3H17V5H15z"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M11 3H13V5H11z"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M7 3H9V5H7z"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M3 3H5V5H3z"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M3 7H5V9H3z"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M3 11H5V13H3z"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M3 15H5V17H3z"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M3 19H5V21H3z"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M3 23H5V25H3z"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M3 27H5V29H3z"
  })), children);
})));
if (false) {}
const Drought = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Drought({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M27,18h3V15a4.0045,4.0045,0,0,0-4-4H25V9.5A3.5042,3.5042,0,0,0,21.5,6a3.4556,3.4556,0,0,0-1.5.3511V5.41a3.41,3.41,0,0,0-6.5449-1.3433L11.3408,9H9a5.0059,5.0059,0,0,0-5,5v4H8a5.0059,5.0059,0,0,0,5-5V10.2051l2.293-5.35A1.41,1.41,0,0,1,18,5.41V22H14.6123L11,25.2939,7.3877,22H2v2H6.6123L11,28l4.3877-4H30V22H20V9.5a1.5,1.5,0,0,1,3,0V14A4.0045,4.0045,0,0,0,27,18Zm-2-5h1a2.0023,2.0023,0,0,1,2,2v1H27a2.0023,2.0023,0,0,1-2-2ZM11,13a3.0033,3.0033,0,0,1-3,3H6V14a3.0033,3.0033,0,0,1,3-3h2Z"
  })), children);
})));
if (false) {}
const Dvr = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Dvr({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M30,15V11a2,2,0,0,0-2-2H22V23h2V17h1.48l2.34,6H30l-2.33-6H28A2,2,0,0,0,30,15Zm-6-4h4v4H24Z"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M18 9 16 22 14 9 12 9 14.52 23 17.48 23 20 9 18 9z"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M6,23H2V9H6a4,4,0,0,1,4,4v6A4,4,0,0,1,6,23ZM4,21H6a2,2,0,0,0,2-2V13a2,2,0,0,0-2-2H4Z"
  })), children);
})));
if (false) {}
const Earth = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Earth({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A14,14,0,1,0,30,16,14.0158,14.0158,0,0,0,16,2Zm5,3.1055a12.0136,12.0136,0,0,1,2.9158,1.8994L23.5034,8H21ZM13.3784,27.7026A11.9761,11.9761,0,0,1,8.1157,6.9761L9.4648,9h3.3423l-1.5,4H7.2793L5.8967,17.1475,8.4648,21h5l1.4319,2.1475ZM16,28c-.2034,0-.4016-.02-.6025-.03l1.3967-4.19a1.9876,1.9876,0,0,0-.2334-1.7412l-1.4319-2.1475A1.9962,1.9962,0,0,0,13.4648,19h-3.93L8.1033,16.8525,8.7207,15H11v2h2V14.1812l2.9363-7.83-1.8726-.7022L13.5571,7H10.5352L9.728,5.7891A11.7941,11.7941,0,0,1,19,4.395V8a2.0025,2.0025,0,0,0,2,2h2.5857A1.9865,1.9865,0,0,0,25,9.4141l.1406-.1407.2818-.68A11.9813,11.9813,0,0,1,27.3,12H22.5986a1.9927,1.9927,0,0,0-1.9719,1.665L20.03,17.1064a1.99,1.99,0,0,0,.991,2.086l2.1647,1.4638,1.4585,3.646A11.9577,11.9577,0,0,1,16,28Zm8.8145-8.6563L22.1,17.5088l-.1-.06L22.5986,14h5.2207a11.743,11.743,0,0,1-1.7441,8.4951Z"
  })), children);
})));
if (false) {}
const EarthAmericas = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function EarthAmericas({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M30,16a14.0313,14.0313,0,1,0-7.14,12.1914l.1165.0254.0249-.1113A13.9983,13.9983,0,0,0,30,16ZM4,16a11.9369,11.9369,0,0,1,.395-3H8.6382L13.63,17.16l-1.9092,2.5459a2.0088,2.0088,0,0,0,.1855,2.6142L14,24.4141v3.4052A12.0093,12.0093,0,0,1,4,16Zm9.32,4.9062L16.37,16.84,9.3618,11H5.1055A11.9619,11.9619,0,0,1,22.8838,6.1865L22.2793,8H16.5859L13.543,11.043l9.3535,8.3134L21.248,26.7749A11.9034,11.9034,0,0,1,16,28V23.5859Zm10.315,4.3443,1.2133-5.46a2.0007,2.0007,0,0,0-.6235-1.9277L16.457,10.957,17.4141,10h4.8652a1.9981,1.9981,0,0,0,1.8975-1.3677l.3532-1.06a11.9777,11.9777,0,0,1-.8947,17.6782Z"
  })), children);
})));
if (false) {}
const EarthAmericasFilled = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function EarthAmericasFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A14,14,0,1,0,30,16,14.0158,14.0158,0,0,0,16,2ZM4,16a11.915,11.915,0,0,1,.7-4H10l5,4-2.8,3.6929A1,1,0,0,0,12.293,21L15,24v3.9492A12.01,12.01,0,0,1,4,16ZM21.4348,26.6846l2.5457-7.6992A1,1,0,0,0,23.614,18L15,11l2-2h5.2793a1,1,0,0,0,.9487-.6836L23.7234,6.83a11.9742,11.9742,0,0,1-2.2886,19.855Z"
  })), children);
})));
if (false) {}
const EarthEuropeAfrica = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function EarthEuropeAfrica({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A14,14,0,1,0,30,16,14.0158,14.0158,0,0,0,16,2ZM4,16A11.96,11.96,0,0,1,8,7.0811V9a2,2,0,0,0,2,2h3.3818a2,2,0,0,0,1.7893-1.106L15.6182,9H18v4H13.2354a2,2,0,0,0-.8936.2109L9.1055,14.8291A2,2,0,0,0,8,16.6177v3.7055A2,2,0,0,0,9.2573,22.18l3.8487,1.54.6779,4.0664A12.0135,12.0135,0,0,1,4,16ZM15.8457,27.9922,14.894,22.28,10,20.3232v-3.705L13.2358,15H20V7H14.3818l-1,2H10V5.6235A11.9578,11.9578,0,0,1,27.3,12H22v4l.9224,3.8135L21,22.6973v4.1972A11.9083,11.9083,0,0,1,16,28C15.948,28,15.8977,27.9927,15.8457,27.9922ZM23,25.7266V23.3027l1.5859-2.3789a2.0027,2.0027,0,0,0,.2769-1.5957L24,15.877V14h3.8193A11.8409,11.8409,0,0,1,23,25.7266Z"
  })), children);
})));
if (false) {}
const EarthEuropeAfricaFilled = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function EarthEuropeAfricaFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A14,14,0,1,0,30,16,14.0158,14.0158,0,0,0,16,2ZM4,16A11.9814,11.9814,0,0,1,9,6.2734V9a1,1,0,0,0,1,1h3.3821a1,1,0,0,0,.8943-.5527L15,8h4v6H13.2361a1.0006,1.0006,0,0,0-.4473.1055L9.5527,15.7236A1,1,0,0,0,9,16.6182v3.7046a1,1,0,0,0,.6287.9287L14,23l.8235,4.94A12.0152,12.0152,0,0,1,4,16ZM22,26.376V23l1.7546-2.6318a1.0012,1.0012,0,0,0,.1382-.7974L23,16V13h4.605A11.901,11.901,0,0,1,22,26.376Z"
  })), children);
})));
if (false) {}
const EarthFilled = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function EarthFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A14,14,0,1,0,30,16,14.0158,14.0158,0,0,0,16,2ZM4.02,16.394l1.3384.4458L7,19.3027v1.2831a1,1,0,0,0,.2929.7071L10,24v2.3765A11.9941,11.9941,0,0,1,4.02,16.394ZM16,28a11.9682,11.9682,0,0,1-2.5718-.2847L14,26l1.8046-4.5116a1,1,0,0,0-.0964-.9261l-1.4113-2.117A1,1,0,0,0,13.4648,18h-4.93L7.2866,16.1274,9.4141,14H11v2h2V13.2656l3.8682-6.7695-1.7364-.9922L14.2769,7H11.5352l-1.086-1.6289A11.861,11.861,0,0,1,20,4.7V8a1,1,0,0,0,1,1h1.4648a1,1,0,0,0,.8321-.4453l.8769-1.3154A12.0331,12.0331,0,0,1,26.8945,11H22.82a1,1,0,0,0-.9806.8039l-.7221,4.4708a1,1,0,0,0,.54,1.0539L25,19l.6851,4.0557A11.9793,11.9793,0,0,1,16,28Z"
  })), children);
})));
if (false) {}
const EarthSoutheastAsia = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function EarthSoutheastAsia({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M14 24H17V26H14z"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M17 22H19V24H17z"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M17 18H19V20H17z"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A14,14,0,1,0,30,16,14.0158,14.0158,0,0,0,16,2Zm-.603,2.03,2.5073,5.0156L16.3228,13H10.271l-1.41,4.3872,2.8521,2.8521L10.7056,21.751,6.2856,19H4.395A11.9363,11.9363,0,0,1,15.397,4.03ZM5.1055,21h.6089l3.9345,2.4487A1.9912,1.9912,0,0,0,12.37,22.86l1.0078-1.5118a2.005,2.005,0,0,0-.25-2.5234l-1.9887-1.9888L11.729,15h4.5938A1.9906,1.9906,0,0,0,18.18,13.7427L19.7612,9.79a2.0019,2.0019,0,0,0-.0674-1.6382L17.6843,4.1323A11.9592,11.9592,0,0,1,26.8945,21H23a2.0023,2.0023,0,0,0-2,2v3.8945A11.9477,11.9477,0,0,1,5.1055,21ZM23,25.7266V23h2.7268A12.0762,12.0762,0,0,1,23,25.7266Z"
  })), children);
})));
if (false) {}
const EarthSoutheastAsiaFilled = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function EarthSoutheastAsiaFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M17 22H19V24H17z"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M17 18H19V20H17z"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M14 24H17V26H14z"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A14,14,0,1,0,30,16,14.0158,14.0158,0,0,0,16,2ZM4.7,20H6l4.1772,2.6a1,1,0,0,0,1.36-.2939l1.0078-1.5118a1,1,0,0,0-.125-1.2617L10,17.1118,11,14h5.323a1,1,0,0,0,.9285-.6284L18.8333,9.417a1,1,0,0,0-.034-.8189L16.5129,4.0259A11.9652,11.9652,0,0,1,26.3762,22H23a1,1,0,0,0-1,1v3.3765A11.9578,11.9578,0,0,1,4.7,20Z"
  })), children);
})));
if (false) {}
const Earthquake = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Earthquake({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6123,2.2139a1.0094,1.0094,0,0,0-1.2427,0L1,13.4194l1.2427,1.5718L4,13.6211V26a2.0041,2.0041,0,0,0,2,2H26a2.0037,2.0037,0,0,0,2-2V13.63L29.7573,15,31,13.4282ZM6,12.0615,15,5.05v7.3638l3.458,3.458-6.7344,4.8105L14.3818,26H6ZM26,26H16.6182l-2.3418-4.6826,7.2656-5.1895L17,11.5859V5.0518l9,7.02Z"
  })), children);
})));
if (false) {}
const EdgeCluster = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function EdgeCluster({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M16,7a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,16,7Zm0-4a1,1,0,1,0,1,1A1.001,1.001,0,0,0,16,3Z"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M11,30a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,11,30Zm0-4a1,1,0,1,0,1,1A1.001,1.001,0,0,0,11,26Z"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M7,11a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,7,11ZM7,7A1,1,0,1,0,8,8,1.001,1.001,0,0,0,7,7Z"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M21,30a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,21,30Zm0-4a1,1,0,1,0,1,1A1.001,1.001,0,0,0,21,26Z"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M25,11a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,25,11Zm0-4a1,1,0,1,0,1,1A1.001,1.001,0,0,0,25,7Z"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M4,21a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,4,21Zm0-4a1,1,0,1,0,1,1A1.001,1.001,0,0,0,4,17Z"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M28,21a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,28,21Zm0-4a1,1,0,1,0,1,1A1.001,1.001,0,0,0,28,17Z"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M16,22a6,6,0,1,1,6-6A6.0069,6.0069,0,0,1,16,22Zm0-10a4,4,0,1,0,4,4A4.0045,4.0045,0,0,0,16,12Z"
  })), children);
})));
if (false) {}
const EdgeDevice = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function EdgeDevice({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M9 21H23V23H9z"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M11,14a2,2,0,1,0,2,2A1.9806,1.9806,0,0,0,11,14Z"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M21,14a2,2,0,1,0,2,2A1.9806,1.9806,0,0,0,21,14Z"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M28,8H18.4141l2.0722-2.0723A2.04,2.04,0,0,0,21,6a2,2,0,1,0-2-2,2.0412,2.0412,0,0,0,.0723.5137L15.5859,8H4a2.0025,2.0025,0,0,0-2,2V26a2.0025,2.0025,0,0,0,2,2H28a2.0025,2.0025,0,0,0,2-2V10A2.0025,2.0025,0,0,0,28,8ZM4,26V10H28V26Z"
  })), children);
})));
if (false) {}
const WatsonHealthEdgeEnhancement = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function WatsonHealthEdgeEnhancement({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8164,4.7646,11.1328,2.887A13.976,13.976,0,0,0,6.9507,5.3278L8.2358,6.8593A11.9729,11.9729,0,0,1,11.8164,4.7646Z"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5913,10,3.86,9a14.14,14.14,0,0,0-1.6382,4.5872l1.9677.3469A12.1519,12.1519,0,0,1,5.5913,10Z"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M16,26A10,10,0,0,0,16,6h0Z"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M30,16A14,14,0,0,0,16,2V4a11.9933,11.9933,0,0,1,4.0493,23.2847c-.1682.06-.334.1294-.5044.1821-.2512.0771-.51.1362-.7683.1973-.1262.03-.25.0693-.3772.0952-.2908.0591-.5884.0976-.8862.1352-.1.0122-.1983.0342-.2988.044A12.0015,12.0015,0,0,1,5.416,21.6548c-.0664-.127-.133-.2534-.1953-.3843-.0547-.1123-.106-.227-.1572-.3413A13.1207,13.1207,0,0,1,4.19,18l-1.9677.4131A13.9173,13.9173,0,0,0,2.7,20.2993l-.0251.0083A13.9615,13.9615,0,0,0,16,30q.7134,0,1.415-.0713c.135-.0137.2654-.042.3995-.06.3286-.0424.6574-.0839.9814-.1494.18-.0366.3533-.0908.5308-.1338.2685-.0659.5383-.125.8027-.2065.2463-.0762.4831-.1724.7234-.2612.18-.0664.3635-.1211.5412-.1953l-.0009-.0025A14.0015,14.0015,0,0,0,30,16Z"
  })), children);
})));
if (false) {}
const WatsonHealthEdgeEnhancement_01 = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function WatsonHealthEdgeEnhancement_01({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M26 28 26 20 24 20 24 21 22 21 22 23 24 23 24 28 22 28 22 30 28 30 28 28 26 28z"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M28,16h2A14,14,0,0,0,16,2V4A12,12,0,0,1,28,16Z"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M26,16A10,10,0,0,0,16,6V16Z"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M16,28A11.96,11.96,0,0,1,5.416,21.6548c-.0664-.127-.133-.2534-.1953-.3843-.0547-.1123-.106-.227-.1572-.3413A13.1207,13.1207,0,0,1,4.19,18l-1.9677.4131A13.9173,13.9173,0,0,0,2.7,20.2993l-.0251.0083A13.9615,13.9615,0,0,0,16,30Z"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5913,10,3.86,9a14.14,14.14,0,0,0-1.6382,4.5872l1.9677.3469A12.1519,12.1519,0,0,1,5.5913,10Z"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8164,4.7646,11.1328,2.887A13.976,13.976,0,0,0,6.9507,5.3278L8.2358,6.8593A11.9729,11.9729,0,0,1,11.8164,4.7646Z"
  })), children);
})));
if (false) {}
const WatsonHealthEdgeEnhancement_02 = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function WatsonHealthEdgeEnhancement_02({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M28,30H22V26a2.002,2.002,0,0,1,2-2h2V22H22V20h4a2.0023,2.0023,0,0,1,2,2v2a2.0023,2.0023,0,0,1-2,2H24v2h4Z"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M28,16h2A14,14,0,0,0,16,2V4A12,12,0,0,1,28,16Z"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M26,16A10,10,0,0,0,16,6V16Z"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M16,28A11.96,11.96,0,0,1,5.416,21.6548c-.0664-.127-.133-.2534-.1953-.3843-.0547-.1123-.106-.227-.1572-.3413A13.1207,13.1207,0,0,1,4.19,18l-1.9677.4131A13.9173,13.9173,0,0,0,2.7,20.2993l-.0251.0083A13.9615,13.9615,0,0,0,16,30Z"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5913,10,3.86,9a14.14,14.14,0,0,0-1.6382,4.5872l1.9677.3469A12.1519,12.1519,0,0,1,5.5913,10Z"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8164,4.7646,11.1328,2.887A13.976,13.976,0,0,0,6.9507,5.3278L8.2358,6.8593A11.9729,11.9729,0,0,1,11.8164,4.7646Z"
  })), children);
})));
if (false) {}
const WatsonHealthEdgeEnhancement_03 = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function WatsonHealthEdgeEnhancement_03({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M26,20H22v2h4v2H23v2h3v2H22v2h4a2.0027,2.0027,0,0,0,2-2V22A2.0023,2.0023,0,0,0,26,20Z"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M28,16h2A14,14,0,0,0,16,2V4A12,12,0,0,1,28,16Z"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M26,16A10,10,0,0,0,16,6V16Z"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M16,28A11.96,11.96,0,0,1,5.416,21.6548c-.0664-.127-.133-.2534-.1953-.3843-.0547-.1123-.106-.227-.1572-.3413A13.1207,13.1207,0,0,1,4.19,18l-1.9677.4131A13.9173,13.9173,0,0,0,2.7,20.2993l-.0251.0083A13.9615,13.9615,0,0,0,16,30Z"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5913,10,3.86,9a14.14,14.14,0,0,0-1.6382,4.5872l1.9677.3469A12.1519,12.1519,0,0,1,5.5913,10Z"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8164,4.7646,11.1328,2.887A13.976,13.976,0,0,0,6.9507,5.3278L8.2358,6.8593A11.9729,11.9729,0,0,1,11.8164,4.7646Z"
  })), children);
})));
if (false) {}
const EdgeNode = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function EdgeNode({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M22 6H26V10H22z"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: "7",
    cy: "7",
    r: "1"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: "25",
    cy: "25",
    r: "1"
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: "25",
    cy: "21",
    r: "1"
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    cx: "25",
    cy: "17",
    r: "1"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M22,17V15H20V14a2.0023,2.0023,0,0,0-2-2H17V10H15v2H13V10H11v2H10a2.0023,2.0023,0,0,0-2,2v1H6v2H8v2H6v2H8v1a2.0023,2.0023,0,0,0,2,2h1v2h2V24h2v2h2V24h1a2.0023,2.0023,0,0,0,2-2V21h2V19H20V17Zm-4,5H10V14h8Z"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M28,30H4a2.0021,2.0021,0,0,1-2-2V4A2.0021,2.0021,0,0,1,4,2H28a2.0021,2.0021,0,0,1,2,2V28A2.0021,2.0021,0,0,1,28,30ZM4,4V28H28V4Z"
  })), children);
})));
if (false) {}
const EdgeNodeAlt = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function EdgeNodeAlt({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M27,22a2.981,2.981,0,0,0-2.0374.811l-4.0039-2.4023a2.0429,2.0429,0,0,0,0-.8174l4.0039-2.4023A2.9909,2.9909,0,1,0,24,15a2.9345,2.9345,0,0,0,.0415.4092l-4.0039,2.4023a3,3,0,1,0,0,4.377l4.0039,2.4023A2.9345,2.9345,0,0,0,24,25a3,3,0,1,0,3-3Zm0-8a1,1,0,1,1-1,1A1.0009,1.0009,0,0,1,27,14Zm-9,7a1,1,0,1,1,1-1A1.0009,1.0009,0,0,1,18,21Zm9,5a1,1,0,1,1,1-1A1.0009,1.0009,0,0,1,27,26Z"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: "7",
    cy: "8",
    r: "1"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: "7",
    cy: "16",
    r: "1"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: "7",
    cy: "24",
    r: "1"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M22,13V5a2.0023,2.0023,0,0,0-2-2H4A2.0023,2.0023,0,0,0,2,5V27a2.0023,2.0023,0,0,0,2,2H20V27H4V21h8V19H4V13ZM4,5H20v6H4Z"
  })), children);
})));
if (false) {}
const EdgeService = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function EdgeService({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M7 11H9V21H7z"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M11 11H13V21H11z"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M15 11H17V21H15z"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M19 11H21V21H19z"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M23 11H25V21H23z"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M28,26H4a2.0023,2.0023,0,0,1-2-2V8A2.0023,2.0023,0,0,1,4,6H28a2.0023,2.0023,0,0,1,2,2V24A2.0023,2.0023,0,0,1,28,26ZM4,8V24H28V8Z"
  })), children);
})));
if (false) {}
const Edit = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Edit({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M2 26H30V28H2z"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4,9c0.8-0.8,0.8-2,0-2.8c0,0,0,0,0,0l-3.6-3.6c-0.8-0.8-2-0.8-2.8,0c0,0,0,0,0,0l-15,15V24h6.4L25.4,9z M20.4,4L24,7.6 l-3,3L17.4,7L20.4,4z M6,22v-3.6l10-10l3.6,3.6l-10,10H6z"
  })), children);
})));
if (false) {}
const EditOff = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function EditOff({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M30,28.6L3.4,2L2,3.4l10.1,10.1L4,21.6V28h6.4l8.1-8.1L28.6,30L30,28.6z M9.6,26H6v-3.6l7.5-7.5l3.6,3.6L9.6,26z"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4,6.2L29.4,6.2l-3.6-3.6c-0.8-0.8-2-0.8-2.8,0l0,0l0,0l-8,8l1.4,1.4L20,8.4l3.6,3.6L20,15.6l1.4,1.4l8-8 C30.2,8.2,30.2,7,29.4,6.2L29.4,6.2z M25,10.6L21.4,7l3-3L28,7.6L25,10.6z"
  })), children);
})));
if (false) {}
const EdtLoop = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function EdtLoop({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M23.625,22.5875a6.1287,6.1287,0,0,1-4.5-1.9l-3.1-3.2-3.1,3.2a6.4582,6.4582,0,0,1-9.1,0,7.028,7.028,0,0,1-1.8-4.7,6.6547,6.6547,0,0,1,1.9-4.7,6.3375,6.3375,0,0,1,9,0l3.1,3.2,3.1-3.2a6.3375,6.3375,0,0,1,9,0,6.8282,6.8282,0,0,1,0,9.4A6.5418,6.5418,0,0,1,23.625,22.5875Zm-6.2-6.6,3.1,3.3a4.4061,4.4061,0,0,0,6.2,0,4.9077,4.9077,0,0,0,0-6.6,4.4061,4.4061,0,0,0-6.2,0Zm-9-4.6a4.1582,4.1582,0,0,0-3.1,1.3,4.8385,4.8385,0,0,0,0,6.6,4.4061,4.4061,0,0,0,6.2,0l3.1-3.3-3.1-3.3A4.7706,4.7706,0,0,0,8.425,11.3875Z"
  })), children);
})));
if (false) {}
const Education = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Education({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M26,30H24V27a5.0059,5.0059,0,0,0-5-5H13a5.0059,5.0059,0,0,0-5,5v3H6V27a7.0082,7.0082,0,0,1,7-7h6a7.0082,7.0082,0,0,1,7,7Z"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M5,6A1,1,0,0,0,4,7v9H6V7A1,1,0,0,0,5,6Z"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M4,2V4H9v7a7,7,0,0,0,14,0V4h5V2Zm7,2H21V7H11Zm5,12a5,5,0,0,1-5-5V9H21v2A5,5,0,0,1,16,16Z"
  })), children);
})));
if (false) {}
const ElementPicker = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function ElementPicker({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M24,18h4c1.1045,0,2-.8955,2-2v-4c0-1.1045-.8955-2-2-2h-4c-1.1045,0-2,.8955-2,2v1h-5v-5c0-1.6543-1.3457-3-3-3h-4v-1c0-1.1045-.8955-2-2-2h-4c-1.1045,0-2,.8955-2,2v4c0,1.1045.8955,2,2,2h4c1.1045,0,2-.8955,2-2v-1h4c.5515,0,1,.4487,1,1v16c0,1.6543,1.3457,3,3,3h4v1c0,1.1045.8955,2,2,2h4c1.1045,0,2-.8955,2-2v-4c0-1.1045-.8955-2-2-2h-4c-1.1045,0-2,.8955-2,2v1h-4c-.5515,0-1-.4487-1-1v-9h5v1c0,1.1045.8955,2,2,2ZM24,12h4v4h-4v-4ZM8,8h-4v-4h4v4Z"
  })), children);
})));
if (false) {}
const Email = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function Email({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Icon_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path286 || (_path286 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M28,6H4A2,2,0,0,0,2,8V24a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V8A2,2,0,0,0,28,6ZM25.8,8,16,14.78,6.2,8ZM4,24V8.91l11.43,7.91a1,1,0,0,0,1.14,0L28,8.91V24Z"
  })), children);
});
if (false) {}
const EmailNew = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function EmailNew({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M19,24H4L3.9966,8.9062l11.4341,7.9161a1.0008,1.0008,0,0,0,1.1386,0L28,8.9087,28,18h2V8a2.0027,2.0027,0,0,0-2-2H4A2.0023,2.0023,0,0,0,2,8V24a2.0027,2.0027,0,0,0,2,2H19ZM25.7986,8,16,14.7837,6.2014,8Z"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: "26",
    cy: "24",
    r: "4"
  })), children);
})));
if (false) {}
const EmissionsManagement = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function EmissionsManagement({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M4,2h-2v26c0,1.1046.8954,2,2,2h11v-2H4V2ZM23,4v2h3.5859l-7.5859,7.5859-4.293-4.293c-.3905-.3905-1.0236-.3905-1.4141,0l-7.293,7.293,1.4141,1.4141,6.5859-6.5859,4.293,4.293c.3905.3904,1.0236.3904,1.4141,0l8.293-8.293v3.5859h2v-7s-7,0-7,0ZM22.48,20.863c-.682-.54-1.544-.863-2.48-.863h-3v3c0,2.206,1.794,4,4,4h1v3h2v-3h1c2.757,0,5-2.243,5-5v-4h-3c-1.933.0016-3.6925,1.116-4.52,2.863ZM22,25h-1c-1.103,0-2-.897-2-2v-1h1c1.103,0,2,.897,2,2v1ZM28,22c0,1.654-1.346,3-3,3h-1v-2c0-1.654,1.346-3,3-3h1v2Z"
  })), children);
})));
if (false) {}
const Encryption = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Encryption({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M29,21.2783V19a4,4,0,0,0-8,0v2.2783A1.9935,1.9935,0,0,0,20,23v5a2.0025,2.0025,0,0,0,2,2h6a2.0025,2.0025,0,0,0,2-2V23A1.9935,1.9935,0,0,0,29,21.2783ZM25,17a2.0025,2.0025,0,0,1,2,2v2H23V19A2.0025,2.0025,0,0,1,25,17ZM22,28V23h6v5Z"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M2 2H4V6H2z"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M14 2H16V6H14z"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M18 2H20V6H18z"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M2 8H4V16H2z"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M2 18H4V26H2z"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M14 18H16V26H14z"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M6 8H8V16H6z"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M18 8H20V14H18z"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M10,26H8a2.0023,2.0023,0,0,1-2-2V20a2.0023,2.0023,0,0,1,2-2h2a2.0023,2.0023,0,0,1,2,2v4A2.0023,2.0023,0,0,1,10,26ZM8,20v4h2V20Z"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M14,16H12a2.0023,2.0023,0,0,1-2-2V10a2.0023,2.0023,0,0,1,2-2h2a2.0023,2.0023,0,0,1,2,2v4A2.0023,2.0023,0,0,1,14,16Zm-2-6v4h2V10Z"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M10,6H8A2.0023,2.0023,0,0,1,6,4V2H8V4h2V2h2V4A2.0023,2.0023,0,0,1,10,6Z"
  })), children);
})));
if (false) {}
const EnergyRenewable = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function EnergyRenewable({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M29,14H28V10H26v4H24V10H22v4H21a1,1,0,0,0-1,1v4a5.0079,5.0079,0,0,0,4,4.8989V27a1.0008,1.0008,0,0,1-1,1H5a1,1,0,0,1,0-2h5a3,3,0,0,0,0-6H5a1,1,0,0,1,0-2h5a3.0033,3.0033,0,0,0,3-3V11h1a4.0045,4.0045,0,0,0,4-4V4H15a3.979,3.979,0,0,0-2.7468,1.1064A6.0041,6.0041,0,0,0,7,2H4V5a6.0066,6.0066,0,0,0,6,6h1v4a1.0008,1.0008,0,0,1-1,1H5a3,3,0,0,0,0,6h5a1,1,0,0,1,0,2H5a3,3,0,0,0,0,6H23a3.0033,3.0033,0,0,0,3-3V23.8989A5.0079,5.0079,0,0,0,30,19V15A1,1,0,0,0,29,14ZM13,8a2.002,2.002,0,0,1,2-2h1V7a2.002,2.002,0,0,1-2,2H13ZM10,9A4.0045,4.0045,0,0,1,6,5V4H7a4.0045,4.0045,0,0,1,4,4V9ZM28,19a3,3,0,0,1-6,0V16h6Z"
  })), children);
})));
if (false) {}
const Enterprise = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Enterprise({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M8 8H10V12H8z"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M8 14H10V18H8z"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M14 8H16V12H14z"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M14 14H16V18H14z"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M8 20H10V24H8z"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M14 20H16V24H14z"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M30,14a2,2,0,0,0-2-2H22V4a2,2,0,0,0-2-2H4A2,2,0,0,0,2,4V30H30ZM4,4H20V28H4ZM22,28V14h6V28Z"
  })), children);
})));
if (false) {}
const EnumerationDefinition = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function EnumerationDefinition({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m19.5328,16.0691c0-.9631.8772-1.4445,1.7885-1.4445,1.0486,0,1.4783.6532,1.4783,1.9257v5.4497h2.2004v-5.6732c0-2.2352-1.0315-3.5072-2.8712-3.5072-1.3922,0-2.1488.7395-2.5096,1.7021h-.0863v-1.4957h-2.2006v8.974h2.2006v-5.9309Z"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "M14.908 19.9883 9.2693 19.9883 9.2693 16.9282 14.2548 16.9282 14.2548 14.917 9.2693 14.917 9.2693 12.0117 14.908 12.0117 14.908 10 7 10 7 22 14.908 22 14.908 19.9883z"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m2,4v24c0,1.1046.8954,2,2,2h24c1.1046,0,2-.8954,2-2V4c0-1.1046-.8954-2-2-2H4c-1.1046,0-2,.8954-2,2Zm26,24H4V4h24v24Z"
  })), children);
})));
if (false) {}
const EnumerationUsage = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function EnumerationUsage({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m19.5328,16.0691c0-.9631.8772-1.4445,1.7885-1.4445,1.0486,0,1.4783.6532,1.4783,1.9257v5.4497h2.2004v-5.6732c0-2.2352-1.0315-3.5072-2.8712-3.5072-1.3922,0-2.1488.7395-2.5096,1.7021h-.0863v-1.4957h-2.2006v8.974h2.2006v-5.9309Z"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "M14.908 19.9883 9.2693 19.9883 9.2693 16.9282 14.2548 16.9282 14.2548 14.917 9.2693 14.917 9.2693 12.0117 14.908 12.0117 14.908 10 7 10 7 22 14.908 22 14.908 19.9883z"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m21,30h-10c-4.9626,0-9-4.0374-9-9v-10C2,6.0374,6.0374,2,11,2h10c4.9626,0,9,4.0374,9,9v10c0,4.9626-4.0374,9-9,9ZM11,4c-3.8599,0-7,3.1401-7,7v10c0,3.8599,3.1401,7,7,7h10c3.8599,0,7-3.1401,7-7v-10c0-3.8599-3.1401-7-7-7h-10Z"
  })), children);
})));
if (false) {}
const EqualApproximately = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function EqualApproximately({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "m20,15c-1.7771,0-3.2314-.8726-4.5144-1.6425-1.1636-.6981-2.2627-1.3575-3.4856-1.3575-1.3977,0-2.449.8629-3.2927,1.707l-1.4146-1.4141c1.0674-1.0675,2.5669-2.293,4.7073-2.293,1.7771,0,3.2314.8726,4.5144,1.6425,1.1636.6981,2.2627,1.3575,3.4856,1.3575,1.3975,0,2.4487-.8629,3.293-1.7072l1.4141,1.4143c-1.0674,1.0675-2.5671,2.2928-4.707,2.2928Z"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "m20,22c-1.7771,0-3.2314-.8726-4.5144-1.6425-1.1636-.6981-2.2627-1.3575-3.4856-1.3575-1.3977,0-2.449.8629-3.2927,1.707l-1.4146-1.4141c1.0674-1.0675,2.5669-2.293,4.7073-2.293,1.7771,0,3.2314.8726,4.5144,1.6425,1.1636.6981,2.2627,1.3575,3.4856,1.3575,1.3975,0,2.4487-.8629,3.293-1.7072l1.4141,1.4143c-1.0674,1.0675-2.5671,2.2928-4.707,2.2928Z"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "m16,30c-7.7197,0-14-6.2804-14-14S8.2802,2,16,2s14,6.2804,14,14-6.2803,14-14,14Zm0-26c-6.6167,0-12,5.3832-12,12s5.3833,12,12,12,12-5.3832,12-12-5.3833-12-12-12Z"
  })), children);
})));
if (false) {}
const Equalizer = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Equalizer({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M2 28H10V30H2z"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M2 24H10V26H2z"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M12 28H20V30H12z"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M12 24H20V26H12z"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M2 20H10V22H2z"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M12 20H20V22H12z"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M2 16H10V18H2z"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M12 16H20V18H12z"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M12 12H20V14H12z"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M12 8H20V10H12z"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M12 4H20V6H12z"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M22 28H30V30H22z"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M22 24H30V26H22z"
  })), children);
})));
if (false) {}
const Erase = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Erase({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M7 27H30V29H7z"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M27.38,10.51,19.45,2.59a2,2,0,0,0-2.83,0l-14,14a2,2,0,0,0,0,2.83L7.13,24h9.59L27.38,13.34A2,2,0,0,0,27.38,10.51ZM15.89,22H8L4,18l6.31-6.31,7.93,7.92Zm3.76-3.76-7.92-7.93L18,4,26,11.93Z"
  })), children);
})));
if (false) {}
const WatsonHealthErase_3D = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function WatsonHealthErase_3D({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4148,16.5132,22.488,8.5859a2.0014,2.0014,0,0,0-2.8291,0L5.6208,22.624a2.0024,2.0024,0,0,0,0,2.8291L10.1663,30h9.5908L30.4148,19.3413A2.001,2.001,0,0,0,30.4148,16.5132ZM18.929,28H10.9949l-3.96-3.9619,6.3123-6.3118,7.9276,7.9276Zm3.76-3.76-7.9276-7.9276L21.074,10l7.9267,7.9272Z"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M11,12H8V2h3a3.0033,3.0033,0,0,1,3,3V9A3.0033,3.0033,0,0,1,11,12Zm-1-2h1a1.0009,1.0009,0,0,0,1-1V5a1.0009,1.0009,0,0,0-1-1H10Z"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M4,2H0V4H4V6H1V8H4v2H0v2H4a2.0027,2.0027,0,0,0,2-2V4A2.0023,2.0023,0,0,0,4,2Z"
  })), children);
})));
if (false) {}
const Error = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Error({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M2,16H2A14,14,0,1,0,16,2,14,14,0,0,0,2,16Zm23.15,7.75L8.25,6.85a12,12,0,0,1,16.9,16.9ZM8.24,25.16A12,12,0,0,1,6.84,8.27L23.73,25.16a12,12,0,0,1-15.49,0Z"
  })), children);
})));
if (false) {}
const ErrorFilled = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function ErrorFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  if (size === 16 || size === "16" || size === "16px") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor",
      ...rest
    }, _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
      d: "M8,1C4.1,1,1,4.1,1,8s3.1,7,7,7s7-3.1,7-7S11.9,1,8,1z M10.7,11.5L4.5,5.3l0.8-0.8l6.2,6.2L10.7,11.5z"
    })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
      fill: "none",
      d: "M10.7,11.5L4.5,5.3l0.8-0.8l6.2,6.2L10.7,11.5z",
      "data-icon-path": "inner-path",
      opacity: "0"
    })), children);
  }
  if (size === 20 || size === "20" || size === "20px") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 20 20",
      fill: "currentColor",
      ...rest
    }, _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
      d: "M10,1c-5,0-9,4-9,9s4,9,9,9s9-4,9-9S15,1,10,1z M13.5,14.5l-8-8l1-1l8,8L13.5,14.5z"
    })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
      d: "M13.5,14.5l-8-8l1-1l8,8L13.5,14.5z",
      "data-icon-path": "inner-path",
      opacity: "0"
    })), children);
  }
  if (size === 24 || size === "24" || size === "24px") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      fill: "currentColor",
      ...rest
    }, _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
      d: "M12,1C5.9,1,1,5.9,1,12s4.9,11,11,11s11-4.9,11-11S18.1,1,12,1z M16.3,17.5L6.5,7.7l1.2-1.2l9.8,9.8L16.3,17.5z"
    })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
      fill: "none",
      d: "M16.3,17.5L6.5,7.7l1.2-1.2l9.8,9.8L16.3,17.5z",
      "data-icon-path": "inner-path",
      opacity: "0"
    })), children);
  }
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M14.9 7.2H17.1V24.799H14.9z",
    "data-icon-path": "inner-path",
    transform: "rotate(-45 16 16)"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A13.914,13.914,0,0,0,2,16,13.914,13.914,0,0,0,16,30,13.914,13.914,0,0,0,30,16,13.914,13.914,0,0,0,16,2Zm5.4449,21L9,10.5557,10.5557,9,23,21.4448Z"
  })), children);
})));
if (false) {}
const ErrorOutline = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function ErrorOutline({
  children,
  size = 16,
  ...rest
}, ref) {
  if (size === 16 || size === "16" || size === "16px") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor",
      ...rest
    }, _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
      d: "M8,1C4.1,1,1,4.1,1,8s3.1,7,7,7s7-3.1,7-7S11.9,1,8,1z M8,14c-3.3,0-6-2.7-6-6s2.7-6,6-6s6,2.7,6,6S11.3,14,8,14z"
    })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
      d: "M7.4 3.6H8.5V12.4H7.4z",
      transform: "rotate(-45 8 8)"
    })), children);
  }
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9 7.2H17.1V24.799H14.9z",
    transform: "rotate(-45 16 16)"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A13.9138,13.9138,0,0,0,2,16,13.9138,13.9138,0,0,0,16,30,13.9138,13.9138,0,0,0,30,16,13.9138,13.9138,0,0,0,16,2Zm0,26A12,12,0,1,1,28,16,12.0353,12.0353,0,0,1,16,28Z"
  })), children);
})));
if (false) {}
const Event = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Event({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M28,6a2,2,0,0,0-2-2H22V2H20V4H12V2H10V4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2h4V26H6V6h4V8h2V6h8V8h2V6h4v6h2Z"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M21 15 23.549 19.938 29 20.729 25 24.573 26 30 21 27.438 16 30 17 24.573 13 20.729 18.6 19.938 21 15z"
  })), children);
})));
if (false) {}
const EventChange = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function EventChange({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M17 15H19V22H17z"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: "18",
    cy: "25",
    r: "1.25"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "m29,30H7c-.3499,0-.6743-.1829-.8555-.4823s-.1926-.6718-.0303-.9817L17.1143,7.536c.1726-.3296.5292-.536.8857-.536s.7131.2064.8857.536l11,21c.1624.3099.1509.6823-.0303.9817s-.5056.4823-.8555.4823Zm-20.3474-2h18.6948l-9.3474-17.8448-9.3474,17.8448Z"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "m7,23H3c-.3467,0-.6685-.1794-.8506-.4742-.1824-.2948-.1987-.663-.0439-.973l2.5-5,1.7891.8945-1.7766,3.5527h2.3821v2Z"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M4.955 11.5H10.545V13.5H4.955z",
    transform: "rotate(-63.435 7.75 12.5)"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "m10.8945,8.4473l-1.7891-.8945,2.5-5c.1694-.3387.532-.5527.8945-.5527s.7251.214.8945.5527l2,4-1.7891.8945-1.1055-2.2112-1.6055,3.2112Z"
  })), children);
})));
if (false) {}
const EventIncident = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function EventIncident({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0176 26.7217 22.016 28.4541 24.9938 26.7322 24.9938 30 26.9907 30 26.9907 26.7316 30.0016 28.4727 31 26.7402 27.9898 24.9996 30.9902 23.2646 29.9918 21.5322 26.9907 23.2677 26.9907 20 24.9938 20 24.9938 23.2672 21.9984 21.5352 21 23.2676 23.9954 24.9996 21.0176 26.7217z"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "m16,23c-.8284,0-1.5.6716-1.5,1.5s.6716,1.5,1.5,1.5,1.5-.6716,1.5-1.5-.6716-1.5-1.5-1.5h0Z"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M15 12H17V21H15z"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "m18,30H3c-.3494,0-.6736-.1824-.8547-.4811-.1814-.2986-.1936-.6703-.0325-.9802L15.1128,3.5387c.1721-.3311.5297-.5387.8872-.5387s.7151.2076.8872.5387l6.76,13-1.7744.9226-5.8728-11.2938L4.6472,28h13.3528v2Z"
  })), children);
})));
if (false) {}
const EventSchedule = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function EventSchedule({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M21,30a8,8,0,1,1,8-8A8,8,0,0,1,21,30Zm0-14a6,6,0,1,0,6,6A6,6,0,0,0,21,16Z"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M22.59 25 20 22.41 20 18 22 18 22 21.59 24 23.59 22.59 25z"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M28,6a2,2,0,0,0-2-2H22V2H20V4H12V2H10V4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2h4V26H6V6h4V8h2V6h8V8h2V6h4v6h2Z"
  })), children);
})));
if (false) {}
const EventWarning = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function EventWarning({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "m27.3803,28h-6.7625l3.3822-6.7642,3.3803,6.7642Zm-3.3803-10c-.3915,0-.7305.2251-.8947.5527l-5,10c-.0674.1348-.1053.2866-.1053.4473,0,.5522.4477,1,1,1h10c.5523,0,1-.4478,1-1,0-.1382-.028-.2695-.0786-.3892l-5.0269-10.0581c-.1641-.3276-.5031-.5527-.8946-.5527h0Z"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "m16,23c-.8284,0-1.5.6716-1.5,1.5s.6716,1.5,1.5,1.5,1.5-.6716,1.5-1.5-.6716-1.5-1.5-1.5h0Z"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M15 12H17V21H15z"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "m15,30H3c-.3494,0-.6736-.1824-.8547-.4811-.1814-.2986-.1936-.6703-.0325-.9802L15.1128,3.5387c.1721-.3311.5297-.5387.8872-.5387s.7151.2076.8872.5387l6,11.5385-1.7744.9226-5.1128-9.8322L4.6472,28h10.3528v2Z"
  })), children);
})));
if (false) {}
const Events = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Events({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M26,14H24v2h2a3.0033,3.0033,0,0,1,3,3v4h2V19A5.0058,5.0058,0,0,0,26,14Z"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M24,4a3,3,0,1,1-3,3,3,3,0,0,1,3-3m0-2a5,5,0,1,0,5,5A5,5,0,0,0,24,2Z"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M23,30H21V28a3.0033,3.0033,0,0,0-3-3H14a3.0033,3.0033,0,0,0-3,3v2H9V28a5.0059,5.0059,0,0,1,5-5h4a5.0059,5.0059,0,0,1,5,5Z"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M16,13a3,3,0,1,1-3,3,3,3,0,0,1,3-3m0-2a5,5,0,1,0,5,5A5,5,0,0,0,16,11Z"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M8,14H6a5.0059,5.0059,0,0,0-5,5v4H3V19a3.0033,3.0033,0,0,1,3-3H8Z"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M8,4A3,3,0,1,1,5,7,3,3,0,0,1,8,4M8,2a5,5,0,1,0,5,5A5,5,0,0,0,8,2Z"
  })), children);
})));
if (false) {}
const EventsAlt = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function EventsAlt({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M18,31h2V29a1.0006,1.0006,0,0,1,1-1h6a1.0006,1.0006,0,0,1,1,1v2h2V29a3.0033,3.0033,0,0,0-3-3H21a3.0033,3.0033,0,0,0-3,3Z"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M24,25a4,4,0,1,1,4-4A4.0039,4.0039,0,0,1,24,25Zm0-6a2,2,0,1,0,2,2A2.0027,2.0027,0,0,0,24,19Z"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M2,31H4V29a1.0009,1.0009,0,0,1,1-1h6a1.0009,1.0009,0,0,1,1,1v2h2V29a3.0033,3.0033,0,0,0-3-3H5a3.0033,3.0033,0,0,0-3,3Z"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "M8,25a4,4,0,1,1,4-4A4.0042,4.0042,0,0,1,8,25Zm0-6a2,2,0,1,0,2,2A2.0023,2.0023,0,0,0,8,19Z"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "M18,16h2V14a1.0009,1.0009,0,0,1,1-1h6a1.0009,1.0009,0,0,1,1,1v2h2V14a3.0033,3.0033,0,0,0-3-3H21a3.0033,3.0033,0,0,0-3,3Z"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "M24,10a4,4,0,1,1,4-4A4.0042,4.0042,0,0,1,24,10Zm0-6a2,2,0,1,0,2,2A2.0023,2.0023,0,0,0,24,4Z"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "M2,16H4V14a1.0013,1.0013,0,0,1,1-1h6a1.0013,1.0013,0,0,1,1,1v2h2V14a3.0033,3.0033,0,0,0-3-3H5a3.0033,3.0033,0,0,0-3,3Z"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "M8,10a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,8,10ZM8,4a2,2,0,1,0,2,2A2.002,2.002,0,0,0,8,4Z"
  })), children);
})));
if (false) {}
const ExamMode = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function ExamMode({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "M25,23v3H7V16.83l3.59,3.58L12,19,6,13,0,19l1.41,1.41L5,16.83V26a2,2,0,0,0,2,2H25a2,2,0,0,0,2-2V23Z"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "M27,7v9.17l3.59-3.58L32,14l-6,6-6-6,1.41-1.41L25,16.17V7H13V5H25A2,2,0,0,1,27,7Z"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "M8,10H4A2,2,0,0,1,2,8V4A2,2,0,0,1,4,2H8a2,2,0,0,1,2,2V8A2,2,0,0,1,8,10ZM4,4V8H8V4Z"
  })), children);
})));
if (false) {}
const ExecutableProgram = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function ExecutableProgram({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M25 21 32 26 25 31 25 21z"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "M20.17 19 17.58 21.59 19 23 23 19 19 15 17.58 16.41 20.17 19z"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "M11.83 19 14.42 16.41 13 15 9 19 13 23 14.42 21.59 11.83 19z"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: "9",
    cy: "8",
    r: "1"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: "6",
    cy: "8",
    r: "1"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "M21,26H4V12H28v7h2V6c0-1.1025-.8972-2-2-2H4c-1.1028,0-2,.8975-2,2V26c0,1.1025,.8972,2,2,2H21v-2ZM4,6H28v4H4V6Z"
  })), children);
})));
if (false) {}
const Exit = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Exit({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "M26 4H28V28H26z"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "M11.414 20.586 7.828 17 22 17 22 15 7.828 15 11.414 11.414 10 10 4 16 10 22 11.414 20.586z"
  })), children);
})));
if (false) {}
const ExpandAll = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function ExpandAll({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "M12,10H26a2.0025,2.0025,0,0,0,2-2V4a2.0025,2.0025,0,0,0-2-2H12a2.0025,2.0025,0,0,0-2,2V5H6V2H4V25a2.0025,2.0025,0,0,0,2,2h4v1a2.0025,2.0025,0,0,0,2,2H26a2.0025,2.0025,0,0,0,2-2V24a2.0025,2.0025,0,0,0-2-2H12a2.0025,2.0025,0,0,0-2,2v1H6V17h4v1a2.0025,2.0025,0,0,0,2,2H26a2.0025,2.0025,0,0,0,2-2V14a2.0025,2.0025,0,0,0-2-2H12a2.0025,2.0025,0,0,0-2,2v1H6V7h4V8A2.0025,2.0025,0,0,0,12,10Zm0-6H26l.0012,4H12Zm0,20H26l.0012,4H12Zm0-10H26l.0012,4H12Z"
  })), children);
})));
if (false) {}
const ExpandCategories = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function ExpandCategories({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "M20 26H26V28H20z"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "M20 18H28V20H20z"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "M20 10H30V12H20z"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "M15 4H17V28H15z"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "M10.586 3.959 7 7.249 3.412 3.958 2 5.373 7 10 12 5.373 10.586 3.959z"
  })), children);
})));
if (false) {}
const Explore = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Explore({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    d: "M22.707,9.2931a.9992.9992,0,0,0-1.0234-.2417l-9,3a1.001,1.001,0,0,0-.6323.6323l-3,9a1,1,0,0,0,1.2651,1.2651l9-3a1.0013,1.0013,0,0,0,.6323-.6324l3-9A1,1,0,0,0,22.707,9.2931ZM11.5811,20.419l2.2094-6.6284L18.21,18.21Z"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
  })), children);
})));
if (false) {}
const Export = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Export({
  children,
  size = 16,
  ...rest
}, ref) {
  if (size === 16 || size === "16" || size === "16px") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor",
      ...rest
    }, _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
      d: "M13,12v2H3v-2H2v2l0,0c0,0.6,0.4,1,1,1h10c0.6,0,1-0.4,1-1l0,0v-2H13z"
    })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
      d: "M3 6 3.7 6.7 7.5 2.9 7.5 12 8.5 12 8.5 2.9 12.3 6.7 13 6 8 1z"
    })), children);
  }
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    d: "M26,24v4H6V24H4v4l.0076-.0049A1.9977,1.9977,0,0,0,6,30H26a2,2,0,0,0,2-2h0V24Z"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    d: "M6 12 7.411 13.405 15 5.825 15 24 17 24 17 5.825 24.591 13.405 26 12 16 2 6 12z"
  })), children);
})));
if (false) {}
const Extensions = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Extensions({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8664,10.1602L25.8664,1.5001c-.2764-.479-.8896-.6431-1.3662-.3662l-7.5,4.3302v-1.464c0-.5522-.4473-1-1-1H4.0002c-.5527,0-1,.4478-1,1v24c0,.5522.4473,1,1,1h24c.5527,0,1-.4478,1-1v-12c0-.5522-.4473-1-1-1h-3.5164l6.0164-3.4736c.4785-.2764.6426-.8877.3662-1.3662ZM5.0002,5.0001h10v10H5.0002V5.0001ZM5.0002,17.0001h10v10H5.0002v-10ZM27.0002,27.0001h-10v-10h10v10ZM17.0002,15.0001v-4.8562l2.8038,4.8562h-2.8038ZM21.7062,14.294l-4-6.9277,6.9277-4,4,6.9277-6.9277,4Z"
  })), children);
})));
if (false) {}
const Eyedropper = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Eyedropper({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    d: "M2 27H5V30H2z"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    d: "M29.71,7.29l-5-5a1,1,0,0,0-1.41,0h0L20,5.59l-1.29-1.3L17.29,5.71,18.59,7,8.29,17.29A1,1,0,0,0,8,18v1.59l-2.71,2.7a1,1,0,0,0,0,1.41h0l3,3a1,1,0,0,0,1.41,0h0L12.41,24H14a1,1,0,0,0,.71-.29L25,13.41l1.29,1.3,1.42-1.42L26.41,12l3.3-3.29a1,1,0,0,0,0-1.41ZM13.59,22h-2L9,24.59,7.41,23,10,20.41v-2l10-10L23.59,12ZM25,10.59,21.41,7,24,4.41,27.59,8Z"
  })), children);
})));
if (false) {}
const FaceActivated = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function FaceActivated({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,26A12,12,0,1,1,28,16,12,12,0,0,1,16,28Z"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5,11A2.5,2.5,0,1,0,14,13.5,2.48,2.48,0,0,0,11.5,11Z"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5,11A2.5,2.5,0,1,0,23,13.5,2.48,2.48,0,0,0,20.5,11Z"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    d: "M9,20a8.13,8.13,0,0,0,14,0Z"
  })), children);
})));
if (false) {}
const FaceActivatedAdd = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function FaceActivatedAdd({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    d: "M30 4 26 4 26 0 24 0 24 4 20 4 20 6 24 6 24 10 26 10 26 6 30 6 30 4z"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5,11A2.5,2.5,0,1,0,14,13.5,2.48,2.48,0,0,0,11.5,11Z"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5,11A2.5,2.5,0,1,0,23,13.5,2.48,2.48,0,0,0,20.5,11Z"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    d: "M9,20a8.13,8.13,0,0,0,14,0Z"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    d: "M27.82,14A12,12,0,1,1,16,4V2A14,14,0,1,0,30,16a14.71,14.71,0,0,0-.16-2Z"
  })), children);
})));
if (false) {}
const FaceActivatedFilled = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function FaceActivatedFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm-4.5,9A2.5,2.5,0,1,1,9,13.5,2.48,2.48,0,0,1,11.5,11ZM16,24a8.11,8.11,0,0,1-7-4H23A8.11,8.11,0,0,1,16,24Zm4.5-8A2.5,2.5,0,1,1,23,13.5,2.48,2.48,0,0,1,20.5,16Z"
  })), children);
})));
if (false) {}




/***/ })

}]);